"use client";
import { jsxs as z, jsx as c, Fragment as se } from "react/jsx-runtime";
import * as t from "react";
import ze, { useState as F, useEffect as Z, useRef as K, createElement as Bt, memo as m, forwardRef as _e, useReducer as Ot, useImperativeHandle as et, useMemo as At } from "react";
import Dt from "focus-trap-react";
import Tt from "react-dom";
function Ft(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var s = {}.hasOwnProperty;
    function a() {
      for (var r = "", o = 0; o < arguments.length; o++) {
        var v = arguments[o];
        v && (r = i(r, n(v)));
      }
      return r;
    }
    function n(r) {
      if (typeof r == "string" || typeof r == "number")
        return r;
      if (typeof r != "object")
        return "";
      if (Array.isArray(r))
        return a.apply(null, r);
      if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
        return r.toString();
      var o = "";
      for (var v in r)
        s.call(r, v) && r[v] && (o = i(o, v));
      return o;
    }
    function i(r, o) {
      return o ? r ? r + " " + o : r + o : r;
    }
    e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
  })();
})(bt);
var Pt = bt.exports;
const g = /* @__PURE__ */ Ft(Pt), Rt = "_alertWithCTA_16hlx_1", Ut = {
  alertWithCTA: Rt
}, vl = ({
  type: e,
  heading: s,
  headingLevel: a,
  cta: n,
  children: i,
  slim: r,
  noIcon: o,
  className: v,
  validation: d,
  ...u
}) => {
  const w = g(
    "usa-alert",
    {
      "usa-alert--success": e === "success",
      "usa-alert--warning": e === "warning",
      "usa-alert--error": e === "error",
      "usa-alert--info": e === "info",
      "usa-alert--slim": r,
      "usa-alert--no-icon": o,
      "usa-alert--validation": d,
      [Ut.alertWithCTA]: !!n
    },
    v
  );
  return /* @__PURE__ */ z("div", { className: w, "data-testid": "alert", ...u, children: [
    /* @__PURE__ */ z("div", { className: "usa-alert__body", children: [
      s && /* @__PURE__ */ c(a, { className: "usa-alert__heading", children: s }),
      i && (d ? i : /* @__PURE__ */ c("p", { className: "usa-alert__text", children: i }))
    ] }),
    n && /* @__PURE__ */ c("div", { children: n })
  ] });
}, Yt = ({
  title: e,
  id: s,
  content: a,
  expanded: n,
  className: i,
  headingLevel: r,
  handleToggle: o
}) => {
  const v = g("usa-accordion__heading", i), d = g(
    "usa-accordion__content",
    "usa-prose",
    i
  );
  return /* @__PURE__ */ z(se, { children: [
    /* @__PURE__ */ c(r, { className: v, children: /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: "usa-accordion__button",
        "aria-expanded": n,
        "aria-controls": s,
        "data-testid": `accordionButton_${s}`,
        onClick: o,
        children: e
      }
    ) }),
    /* @__PURE__ */ c(
      "div",
      {
        id: s,
        "data-testid": `accordionItem_${s}`,
        className: d,
        hidden: !n,
        children: a
      }
    )
  ] });
}, gl = ({
  bordered: e,
  items: s,
  className: a,
  multiselectable: n = !1
}) => {
  const [i, r] = F(
    s.filter((d) => !!d.expanded).map((d) => d.id)
  ), o = g(
    "usa-accordion",
    {
      "usa-accordion--bordered": e
    },
    a
  ), v = (d) => {
    const u = [...i], w = i.indexOf(d), f = n;
    w > -1 ? u.splice(w, 1) : (f || u.splice(0, u.length), u.push(d)), r(u);
  };
  return /* @__PURE__ */ c(
    "div",
    {
      className: o,
      "data-testid": "accordion",
      "data-allow-multiple": n || void 0,
      children: s.map((d, u) => /* @__PURE__ */ c(
        Yt,
        {
          ...d,
          expanded: i.indexOf(d.id) > -1,
          handleToggle: (w) => {
            d.handleToggle && d.handleToggle(w), v(d.id);
          }
        },
        `accordionItem_${u}`
      ))
    }
  );
}, Se = ({
  type: e,
  children: s,
  secondary: a,
  base: n,
  accentStyle: i,
  outline: r,
  inverse: o,
  size: v,
  unstyled: d,
  onClick: u,
  className: w,
  ...f
}) => {
  const _ = g(
    "usa-button",
    {
      "usa-button--secondary": a,
      "usa-button--base": n,
      "usa-button--accent-cool": i === "cool",
      "usa-button--accent-warm": i === "warm",
      "usa-button--outline": r,
      "usa-button--inverse": o,
      "usa-button--big": v === "big",
      "usa-button--unstyled": d
    },
    w
  );
  return /* @__PURE__ */ c(
    "button",
    {
      type: e,
      className: _,
      onClick: u,
      "data-testid": "button",
      ...f,
      children: s
    }
  );
}, ul = ({
  className: e,
  children: s,
  type: a = "default",
  ...n
}) => {
  const i = g(
    "usa-button-group",
    {
      "usa-button-group--segmented": a == "segmented"
    },
    e
  );
  return /* @__PURE__ */ c("ul", { className: i, ...n, children: ze.Children.map(s, (r) => /* @__PURE__ */ c("li", { className: "usa-button-group__item", children: r })) });
};
function Ye(e) {
  return "asCustom" in e;
}
const Wt = (e) => {
  e.key === " " && e.target && (e.preventDefault(), e.target.click());
};
function ot(e, s) {
  return e === "unstyled" ? s : g(
    "usa-link",
    { "usa-link--external": e === "external", "usa-nav__link": e === "nav" },
    s
  );
}
function ue(e) {
  if (Ye(e)) {
    const { variant: s, className: a, asCustom: n, children: i, ...r } = e, o = r, v = ot(s, a);
    return ze.createElement(
      n,
      {
        className: v,
        ...o
      },
      i
    );
  } else {
    const {
      children: s,
      className: a,
      variant: n,
      allowSpacebarActivation: i = !1,
      ...r
    } = e, o = ot(n, a);
    return /* @__PURE__ */ c(
      "a",
      {
        className: o,
        ...i && { onKeyDown: Wt },
        ...r,
        children: s
      }
    );
  }
}
const Ie = {
  "smooth-scroll": "_smooth-scroll_zpzmq_2"
}, wl = ({
  className: e,
  content: s,
  headingLevel: a = "h4",
  mainProps: n,
  navProps: i,
  rootMargin: r = "0px 0px 0px 0px",
  scrollOffset: o,
  threshold: v = 1,
  title: d = "On this page",
  ...u
}) => {
  const w = g("usa-in-page-nav", Ie.target, e), { className: f, ..._ } = i || {}, k = g("usa-in-page-nav__nav", f), { className: b, ...M } = n || {}, B = g("main-content", b), x = a, $ = {
    "--margin-offset": o
  }, [p, N] = F(""), A = s.props.children.filter(
    (L) => L.type === "h2" || L.type === "h3"
  ), V = (L) => {
    L.forEach((y) => {
      y.isIntersecting && N(y.target.id);
    });
  }, E = {
    root: null,
    rootMargin: r,
    threshold: [v]
  }, S = new IntersectionObserver(V, E);
  return Z(() => {
    var L;
    return document.querySelectorAll("h2,h3").forEach((y) => S.observe(y)), (L = document.querySelector("html")) == null || L.classList.add(Ie["smooth-scroll"]), () => {
      var y;
      (y = document.querySelector("html")) == null || y.classList.remove(Ie["smooth-scroll"]);
    };
  }), /* @__PURE__ */ z("div", { className: "usa-in-page-nav-container", ...u, children: [
    /* @__PURE__ */ c(
      "aside",
      {
        className: w,
        "aria-label": d,
        "data-testid": "InPageNavigation",
        children: /* @__PURE__ */ z("nav", { className: k, ..._, children: [
          /* @__PURE__ */ c(x, { className: "usa-in-page-nav__heading", tabIndex: 0, children: d }),
          /* @__PURE__ */ c("ul", { className: "usa-in-page-nav__list", children: A.map((L) => {
            const y = L.props.children, O = L.props.id, D = g("usa-in-page-nav__item", {
              "usa-in-page-nav__item--sub-item": L.type === "h3"
            }), H = g("usa-in-page-nav__link", {
              "usa-current": O === p
            });
            return /* @__PURE__ */ c("li", { className: D, children: /* @__PURE__ */ c(ue, { href: `#${O}`, className: H, children: y }) }, `usa-in-page-nav__item_${y}`);
          }) })
        ] })
      }
    ),
    /* @__PURE__ */ c(
      "main",
      {
        id: "main-content",
        className: B,
        ...M,
        style: o ? $ : void 0,
        children: s
      }
    )
  ] });
}, rt = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-media-block__body", s);
  return /* @__PURE__ */ c("div", { className: n, ...a, children: e });
}, Kt = "_fixed_1khz6_1", It = {
  fixed: Kt
}, pl = ({
  bordered: e,
  caption: s,
  children: a,
  className: n,
  fullWidth: i,
  fixed: r,
  scrollable: o,
  striped: v,
  compact: d,
  stackedStyle: u = "none"
}) => {
  const w = g(
    "usa-table",
    {
      "usa-table--borderless": !e,
      "width-full": i,
      [`${It.fixed}`]: r,
      "usa-table--striped": v,
      "usa-table--compact": d,
      "usa-table--stacked": u === "default",
      "usa-table--stacked-header": u === "headers"
    },
    n
  );
  d && u !== "none" && console.warn(
    "USWDS states that compact styling is not suitable for use with stacked variants. See USWDS Table component, Table variants for more information: https://designsystem.digital.gov/components/table"
  );
  const f = /* @__PURE__ */ z("table", { className: w, "data-testid": "table", children: [
    s && /* @__PURE__ */ c("caption", { children: s }),
    a
  ] });
  return /* @__PURE__ */ c(se, { children: o ? /* @__PURE__ */ c(
    "div",
    {
      "data-testid": "scrollable-table-container",
      className: "usa-table-container--scrollable",
      tabIndex: 0,
      children: f
    }
  ) : f });
}, fl = ({
  children: e,
  background: s,
  className: a,
  ...n
}) => {
  const i = {};
  s && (i.background = s);
  const r = g("usa-tag", a);
  return /* @__PURE__ */ c(
    "span",
    {
      "data-testid": "tag",
      className: r,
      style: { ...i },
      ...n,
      children: e
    }
  );
}, Zt = (e, s = window, a = document.documentElement) => {
  const n = e.getBoundingClientRect();
  return n.top >= 0 && n.left >= 0 && n.bottom <= (s.innerHeight || a.clientHeight) && n.right <= (s.innerWidth || a.clientWidth);
}, lt = (e, s) => parseInt(window.getComputedStyle(e).getPropertyValue(s), 10), Ne = (e, s, a) => lt(a, `margin-${e}`) > 0 ? s - lt(a, `margin-${e}`) : s;
function Gt(e) {
  return "asCustom" in e;
}
const Te = 5, jt = "top";
function Ml({
  position: e = jt,
  wrapperclasses: s,
  className: a,
  ...n
}) {
  const i = K(null), r = K(null), o = K(
    `tooltip-${Math.floor(Math.random() * 9e5) + 1e5}`
  ), [v, d] = F(!1), [u, w] = F(!1), [f, _] = F(void 0), [k, b] = F(0), [M, B] = F(!1), [x, $] = F({}), p = (H, P) => {
    const j = Ne("top", H.offsetHeight, P), G = Ne("left", H.offsetWidth, P);
    _("top"), $({
      left: "50%",
      top: `-${Te}px`,
      margin: `-${j}px 0 0 -${G / 2}px`
    });
  }, N = (H, P) => {
    const j = Ne("left", H.offsetWidth, P);
    _("bottom"), $({
      left: "50%",
      margin: `${Te}px 0 0 -${j / 2}px`
    });
  }, A = (H, P) => {
    const j = Ne("top", H.offsetHeight, P);
    _("right"), $({
      top: "50%",
      left: `${P.offsetLeft + P.offsetWidth + Te}px`,
      margin: `-${j / 2}px 0 0 0`
    });
  }, V = (H, P) => {
    const j = Ne("top", H.offsetHeight, P), G = Ne(
      "left",
      P.offsetLeft > H.offsetWidth ? P.offsetLeft - H.offsetWidth : H.offsetWidth,
      P
    );
    _("left"), $({
      top: "50%",
      left: `-${Te}px`,
      margin: `-${j / 2}px 0 0 ${P.offsetLeft > H.offsetWidth ? G : -G}px`
    });
  }, E = [p, N, A, V], S = E.length;
  Z(() => {
    if (v && i.current && r.current) {
      const H = i.current, P = r.current;
      if (Zt(P))
        w(!0);
      else {
        const G = k;
        if (G < S || M === !1)
          if (b((ee) => ee + 1), G < S) {
            const ee = E[parseInt(`${G}`)];
            ee(P, H);
          } else
            B(!0), b(0);
        else
          console.warn(
            "No visible position found - this may mean your tooltip contents is too long!"
          );
      }
    }
  }, [f, x, M]), Z(() => {
    if (!v)
      w(!1), B(!1), b(0);
    else if (i.current && r.current) {
      const H = i.current, P = r.current;
      switch (e) {
        case "top":
          p(P, H);
          break;
        case "bottom":
          N(P, H);
          break;
        case "right":
          A(P, H);
          break;
        case "left":
          V(P, H);
          break;
      }
    }
  }, [v]);
  const L = () => {
    d(!0);
  }, y = () => {
    d(!1);
  }, O = g("usa-tooltip", s), D = g("usa-tooltip__body", {
    "is-set": v,
    "usa-tooltip__body--top": f === "top",
    "usa-tooltip__body--bottom": f === "bottom",
    "usa-tooltip__body--right": f === "right",
    "usa-tooltip__body--left": f === "left",
    "is-visible": u,
    // isShown is set after positioning updated, to prevent jitter when position changes
    "usa-tooltip__body--wrap": v && M
  });
  if (Gt(n)) {
    const { label: H, title: P, asCustom: j, children: G, ...ee } = n, ie = ee, U = g("usa-tooltip__trigger", a), X = Bt(
      j,
      {
        ...ie,
        ref: i,
        "data-testid": "triggerElement",
        "aria-describedby": o.current,
        tabIndex: 0,
        title: "",
        onMouseEnter: L,
        onMouseOver: L,
        onFocus: L,
        onMouseLeave: y,
        onBlur: y,
        onKeyDown: y,
        className: U
      },
      G
    );
    return /* @__PURE__ */ z("span", { "data-testid": "tooltipWrapper", className: O, children: [
      X,
      /* @__PURE__ */ c(
        "span",
        {
          "data-testid": "tooltipBody",
          title: P ?? (typeof H == "string" ? H : void 0),
          id: o.current,
          ref: r,
          className: D,
          role: "tooltip",
          "aria-hidden": !v,
          style: x,
          children: H
        }
      )
    ] });
  } else {
    const { label: H, title: P, children: j, ...G } = n, ee = g(
      "usa-button",
      "usa-tooltip__trigger",
      a
    );
    return /* @__PURE__ */ z("span", { "data-testid": "tooltipWrapper", className: O, children: [
      /* @__PURE__ */ c(
        "button",
        {
          ...G,
          "data-testid": "triggerElement",
          ref: i,
          "aria-describedby": o.current,
          tabIndex: 0,
          type: "button",
          className: ee,
          title: "",
          onMouseEnter: L,
          onMouseOver: L,
          onFocus: L,
          onMouseLeave: y,
          onBlur: y,
          onKeyDown: y,
          children: j
        }
      ),
      /* @__PURE__ */ c(
        "span",
        {
          "data-testid": "tooltipBody",
          title: P ?? (typeof H == "string" ? H : void 0),
          id: o.current,
          ref: r,
          className: D,
          role: "tooltip",
          "aria-hidden": !v,
          style: x,
          children: H
        }
      )
    ] });
  }
}
const xl = ({
  items: e,
  isSubnav: s = !1
}) => {
  const a = g({
    "usa-sidenav": !s,
    "usa-sidenav__sublist": s
  });
  return /* @__PURE__ */ c("ul", { className: a, "data-testid": "sidenav", children: e.map((n, i) => /* @__PURE__ */ c("li", { className: "usa-sidenav__item", children: n }, `sidenav_item_${i}`)) });
}, qt = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" })), Qt = m(qt), Jt = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 17, cy: 4.54, r: 2 }), /* @__PURE__ */ t.createElement("path", { d: "M14 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C17.42 8.5 16.44 7 14.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L7.22 10l1.92.53L9.79 9H12l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H17v5h2v-5.5c0-1.1-.9-2-2-2z" })), Xt = m(Jt), e1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z" })), t1 = m(e1), s1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z" })), a1 = m(s1), n1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z" })), c1 = m(n1), i1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" })), o1 = m(i1), r1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" })), l1 = m(r1), h1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" })), m1 = m(h1), d1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m22 5.72-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" })), v1 = m(d1), g1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" })), u1 = m(g1), w1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z" })), p1 = m(w1), f1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })), M1 = m(f1), x1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" })), E1 = m(x1), b1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m7 10 5 5 5-5z" })), z1 = m(b1), S1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m7 14 5-5 5 5z" })), _1 = m(S1), C1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" })), N1 = m(C1), y1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" })), L1 = m(y1), k1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m14 12-2 2-2-2 2-2 2 2zm-2-6 2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6 2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z" })), $1 = m(k1), H1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" })), V1 = m(H1), B1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" })), O1 = m(B1), A1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" })), D1 = m(A1), T1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z" })), F1 = m(T1), P1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.86 1.28-3.41 3-3.86V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86zM6 12v2h10v2h2v-4H6z" })), R1 = m(P1), U1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 7, cy: 7, r: 2 }), /* @__PURE__ */ t.createElement("path", { d: "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 0 1 1.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 0 0 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2z" })), Y1 = m(U1), W1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 10.13a33.86 33.86 0 0 1-10 0 1.92 1.92 0 0 1-1.51-1.46 10.42 10.42 0 0 1 0-4.84 1.92 1.92 0 0 1 1.57-1.46 33.86 33.86 0 0 1 10 0 1.9 1.9 0 0 1 1.56 1.46 10.16 10.16 0 0 1 0 4.84A1.9 1.9 0 0 1 17 10.13Zm4 12.12H7a5.25 5.25 0 0 1 0-10.5h10a3.25 3.25 0 0 1 0 6.5H7a1.25 1.25 0 0 1 0-2.5h10a.75.75 0 0 0 0-1.5H7a2.75 2.75 0 0 0 0 5.5h14a1.25 1.25 0 0 1 0 2.5Z" })), K1 = m(W1), I1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z" })), Z1 = m(I1), G1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 8h-2.81a5.985 5.985 0 0 0-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z" })), j1 = m(G1), q1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" })), Q1 = m(q1), J1 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" })), X1 = m(J1), es = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z" })), ts = m(es), ss = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", d: "m12 5 8 13h2v2H2v-2h2l8-13zm.05 8-2.69 5h5.38l-2.69-5zM5.5 3l-.018.024A2.5 2.5 0 0 0 7.498 7 2.5 2.5 0 1 1 5.5 3z" })), as = m(ss), ns = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" })), cs = m(ns), is = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" })), os = m(is), rs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" })), ls = m(rs), hs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" })), ms = m(hs), ds = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })), vs = m(ds), gs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })), us = m(gs), ws = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21.6 18.2 13 11.75v-.91a3.496 3.496 0 0 0-.18-6.75A3.51 3.51 0 0 0 8.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z" })), ps = m(ws), fs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m16.99 5 .63 1.37 1.37.63-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63.63-1.37M11 6.13V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.899 4.899 0 0 0 13 2H7.5v2H9v2.14A5.007 5.007 0 0 0 5.26 9.5h3.98L15 11.65v-.62a5 5 0 0 0-4-4.9zM1 22h4V11H1v11zm19-5h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2zm0-3c1.1 0 2-.9 2-2s-2-4-2-4-2 2.9-2 4 .9 2 2 2z" })), Ms = m(fs), xs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.7 2.37 15 2.3V4a3 3 0 0 1-6 0V2.3l-.7.07a7 7 0 0 0-6.3 7V20h3V10h1.5v12h11V10H19v10h3V9.33a7 7 0 0 0-6.3-6.96Z" })), Es = m(xs), bs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })), zs = m(bs), Ss = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z" })), _s = m(Ss), Cs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z" })), Ns = m(Cs), ys = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" })), Ls = m(ys), ks = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" })), $s = m(ks), Hs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 14H9a9 9 0 0 1 9-9v2c-3.87 0-7 3.13-7 7zm7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3zM7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm4.45.5h-2A2.99 2.99 0 0 1 6.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.97 4.97 0 0 0 3.45-4.24zM19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1h-3a2.99 2.99 0 0 1-2.95-2.5h-2A4.97 4.97 0 0 0 16 19.74V22h6v-2.5c0-.83-.67-1.5-1.5-1.5z" })), Vs = m(Hs), Bs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m13.783 15.172 2.121-2.121 5.996 5.996-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49a3 3 0 0 0-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z" })), Os = m(Bs), As = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 10.5, cy: 4.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M19.59 16h-1.27l-.64.71h-1.27L15.14 21h1.27l.64-.71h1.9l.64.71h1.27l-1.27-5zm-5.21-3.28L14 14.19l-3.8-1.26-.1-.16.52-3.13c.93 1.37 2.15 2.11 4.6 2.11v-1.5c-2.44 0-3.09-.77-3.9-2.39a2.65 2.65 0 0 0-3-1.59L3.75 7.41v3.38l-1.51-.5-.48 1.42 4.35 1.45L5 20.86l2 .28 1-7.34.38.13L10 16.3V21h2v-5.3l-.49-.7 2 .67-.37 1.27 1.91.57 1.24-4.19Zm-9.13-1.43v-2.7l1.57-.4-.49 3.46Z" })), Ds = m(As), Ts = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 16 17.43V18z" })), Fs = m(Ts), Ps = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" })), Rs = m(Ps), Us = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21.25 10.5c-.41 0-.75.34-.75.75h-1.54a6.978 6.978 0 0 0-1.52-3.65l1.09-1.09.01.01c.29.29.77.29 1.06 0s.29-.77 0-1.06L18.54 4.4a.754.754 0 0 0-1.06 0c-.29.29-.29.76-.01 1.05l-1.09 1.09a7.015 7.015 0 0 0-3.64-1.51V3.5h.01c.41 0 .75-.34.75-.75S13.16 2 12.75 2h-1.5c-.41 0-.75.34-.75.75s.33.74.74.75v1.55c-1.37.14-2.62.69-3.64 1.51L6.51 5.47l.01-.01c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L4.4 5.46c-.29.29-.29.77 0 1.06.29.29.76.29 1.05.01l1.09 1.09a6.89 6.89 0 0 0-1.5 3.63H3.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75h1.54c.15 1.37.69 2.61 1.5 3.63l-1.09 1.09a.742.742 0 0 0-1.05.01c-.29.29-.29.77 0 1.06l1.06 1.06c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.01-.01 1.09-1.09c1.02.82 2.26 1.36 3.63 1.51v1.55c-.41.01-.74.34-.74.75s.34.75.75.75h1.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.01v-1.54c1.37-.14 2.62-.69 3.64-1.51l1.09 1.09c-.29.29-.28.76.01 1.05.29.29.77.29 1.06 0l1.06-1.06c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.01.01-1.09-1.09a7.025 7.025 0 0 0 1.52-3.65h1.54c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c.01-.4-.33-.74-.74-.74zM13.75 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1.75-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8.5 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1.75 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm.75-4c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z" })), Ys = m(Us), Ws = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" })), Ks = m(Ws), Is = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M22 9 12 2 2 9h9v13h2V9z" }), /* @__PURE__ */ t.createElement("path", { d: "m4.14 12-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zm14.96 4H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z" })), Zs = m(Is), Gs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" })), js = m(Gs), qs = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z" })), Qs = m(qs), Js = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m21.41 10.59-7.99-8c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0l7.99-8c.79-.79.79-2.05 0-2.83zM13.5 14.5V12H10v3H8v-4c0-.55.45-1 1-1h4.5V7.5L17 11l-3.5 3.5z" })), Xs = m(Js), ea = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10 2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z" })), ta = m(ea), sa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z" })), aa = m(sa), na = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" })), ca = m(na), ia = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7" })), oa = m(ia), ra = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" })), la = m(ra), ha = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m13 10.17-2.5-2.5V2.25a1.25 1.25 0 0 1 2.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 0 0-2.5 0V11h-1V3.25a1.25 1.25 0 0 0-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm3.5 5.92-2.5-2.5V2.25a1.25 1.25 0 0 1 2.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 0 0-2.5 0V11h-1V3.25a1.25 1.25 0 0 0-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm11.69 16.94L2.81 2.81 1.39 4.22l5.63 5.63L7 9.83v4.3c-1.11-.64-2.58-1.47-2.6-1.48-.17-.09-.34-.14-.54-.14-.26 0-.5.09-.7.26-.04.01-1.16 1.11-1.16 1.11l6.8 7.18c.57.6 1.35.94 2.18.94H17c.62 0 1.18-.19 1.65-.52l-.02-.02 1.15 1.15 1.41-1.42z" })), ma = m(ha), da = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z" })), va = m(da), ga = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ t.createElement("path", { d: "M6.05 8.05a7.001 7.001 0 0 0-.02 9.88c1.47-3.4 4.09-6.24 7.36-7.93A15.952 15.952 0 0 0 8 19.32c2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z" })), ua = m(ga), wa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" })), pa = m(wa), fa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zm-1 3h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zm-8-3h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z" }), /* @__PURE__ */ t.createElement("path", { d: "M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z" })), Ma = m(fa), xa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0 0 11 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 0 0 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" })), Ea = m(xa), ba = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" })), za = m(ba), Sa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })), _a = m(Sa), Ca = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" })), Na = m(Ca), ya = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" })), La = m(ya), ka = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" })), $a = m(ka), Ha = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ t.createElement("path", { d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" })), Va = m(Ha), Ba = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m4 18 8.5-6L4 6v12zm9-12v12l8.5-6L13 6z" })), Oa = m(Ba), Aa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 18V6l-8.5 6 8.5 6zm.5-6 8.5 6V6l-8.5 6z" })), Da = m(Aa), Ta = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" })), Fa = m(Ta), Pa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" })), Ra = m(Pa), Ua = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 9h-1V4H8v16h14v-8c0-1.66-1.34-3-3-3zm-9-3h6v3h-6V6zm4 11h-4v-5h4v5zm2 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4.5 8A2.5 2.5 0 0 0 2 10.5v8a2.5 2.5 0 0 0 5 0v-8A2.5 2.5 0 0 0 4.5 8z" })), Ya = m(Ua), Wa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" })), Ka = m(Wa), Ia = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-5-5zM6 20V4h8v4h4v12H6zm10-10v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V8.5a2.5 2.5 0 0 1 2.76-2.49c1.3.13 2.24 1.32 2.24 2.63V15h-2V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V15c0 1.1.9 2 2 2s2-.9 2-2v-5h2z" })), Za = m(Ia), Ga = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" })), ja = m(Ga), qa = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61z" })), Qa = m(qa), Ja = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" })), Xa = m(Ja), e2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 0 1-.44.28zM3.5 9.72a.499.499 0 0 1-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 0 1-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 0 0-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 0 1-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 0 1-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 0 1-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z" })), t2 = m(e2), s2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" })), a2 = m(s2), n2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z" })), c2 = m(n2), i2 = (e) => /* @__PURE__ */ t.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M6.459 17a4.444 4.444 0 0 1-4.116-2.768 4.541 4.541 0 0 1 .954-4.909 4.405 4.405 0 0 1 4.845-.982 4.5 4.5 0 0 1 2.747 4.159 4.514 4.514 0 0 1-1.292 3.181A4.403 4.403 0 0 1 6.459 17Zm11.111 0a4.444 4.444 0 0 1-4.116-2.768 4.541 4.541 0 0 1 .954-4.909 4.405 4.405 0 0 1 4.845-.982A4.5 4.5 0 0 1 22 12.5a4.514 4.514 0 0 1-1.292 3.181A4.403 4.403 0 0 1 17.57 17Z" })), o2 = m(i2), r2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" })), l2 = m(r2), h2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 18.16a6 6 0 0 0-2.95.8 4.08 4.08 0 0 1-2.05.6 3.81 3.81 0 0 1-2-.56 5.84 5.84 0 0 0-5.9 0 4.05 4.05 0 0 1-2 .6v2a6 6 0 0 0 3-.8 4.05 4.05 0 0 1 1.9-.69 3.87 3.87 0 0 1 2.05.6 5.84 5.84 0 0 0 5.9 0 4.08 4.08 0 0 1 2.05-.6 3.81 3.81 0 0 1 2.05.6 5.9 5.9 0 0 0 2.95.8v-2a3.81 3.81 0 0 1-2-.51 6 6 0 0 0-3-.84Zm3-3.65a6.8 6.8 0 0 0-2-.71V10h3l-9-7-9 7h3v3.8a6.8 6.8 0 0 0-1.95.71 4.15 4.15 0 0 1-2 .6v1.95a6.07 6.07 0 0 0 3-.8 3.8 3.8 0 0 1 4.1 0 5.87 5.87 0 0 0 2.95.8 6 6 0 0 0 2.95-.8 3.8 3.8 0 0 1 4.1 0 5.9 5.9 0 0 0 2.95.8v-1.95a3.81 3.81 0 0 1-2.1-.6Zm-9.95 0V11h4v3.54a4.19 4.19 0 0 1-2 .57 3.8 3.8 0 0 1-2.05-.57Z" })), m2 = m(h2), d2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" })), v2 = m(d2), g2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z" })), u2 = m(g2), w2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" })), p2 = m(w2), f2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z" })), M2 = m(f2), x2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" })), E2 = m(x2), b2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.22.68-.48v-1.7C6.73 19.91 6.14 18 6.14 18A2.69 2.69 0 0 0 5 16.5c-.91-.62.07-.61.07-.61a2.13 2.13 0 0 1 1.53 1 2.14 2.14 0 0 0 2.91.83 2.16 2.16 0 0 1 .63-1.34c-2.14-.21-4.52-1.07-4.52-4.9a3.89 3.89 0 0 1 1-2.69 3.57 3.57 0 0 1 .1-2.64s.84-.27 2.75 1a9.63 9.63 0 0 1 5 0c1.91-1.29 2.75-1 2.75-1a3.57 3.57 0 0 1 .1 2.64 3.89 3.89 0 0 1 1 2.69c0 3.84-2.34 4.68-4.57 4.93a2.39 2.39 0 0 1 .68 1.85v2.75c0 .33.18.58.69.48A10 10 0 0 0 12 2Z", fillRule: "evenodd" })), z2 = m(b2), S2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", d: "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z" })), _2 = m(S2), C2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 1c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm4.51-8.95C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zm4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z" })), N2 = m(C2), y2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 0 0 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0 0 20 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z" })), L2 = m(y2), k2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0 0 21 18h-2c0 1.1-.9 2-2 2zM7.64 2.64 6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0z" })), $2 = m(k2), H2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" })), V2 = m(H2), B2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" })), O2 = m(B2), A2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" })), D2 = m(A2), T2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" })), F2 = m(T2), P2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" })), R2 = m(P2), U2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm-3 14h-2v-4h-4v4H8V7h2v4h4V7h2Z" })), Y2 = m(U2), W2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" })), K2 = m(W2), I2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5-4-4V4h8v3.5l-4 4z" })), Z2 = m(I2), G2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 12a7 7 0 0 0-6.34-7 27.32 27.32 0 0 1 2.21-2.09.44.44 0 0 0-.29-.78 10.62 10.62 0 0 0-9.17 7.5 4.26 4.26 0 0 0-.15.47v.06A7.18 7.18 0 0 0 5 12a7 7 0 0 0 6.35 7 27.71 27.71 0 0 1-2.21 2.1.44.44 0 0 0 .29.78 10.65 10.65 0 0 0 9.23-7.69v-.14c0-.05.05-.13.07-.2A6.76 6.76 0 0 0 19 12Zm-7 3.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5Z" })), j2 = m(G2), q2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 14.14C11 13.38 9.33 13 8.5 13S6 13.38 6 14.14V15h5Z" }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 10.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-7 13H4V7h9Zm7 0h-5v-2h5Zm0-4h-5v-2h5Zm0-4h-5V7h5Z" })), Q2 = m(q2), J2 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" })), X2 = m(J2), en = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" })), tn = m(en), sn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }), /* @__PURE__ */ t.createElement("path", { d: "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" })), an = m(sn), nn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z" }), /* @__PURE__ */ t.createElement("path", { d: "m15 9 .94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11 4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z" })), cn = m(nn), on = (e) => /* @__PURE__ */ t.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8.273 3.063c-.958.045-1.612.198-2.184.423a4.41 4.41 0 0 0-1.592 1.04 4.409 4.409 0 0 0-1.035 1.596c-.222.572-.372 1.227-.414 2.185-.042.958-.052 1.266-.047 3.71.005 2.444.016 2.75.062 3.71.046.958.198 1.612.423 2.184a4.41 4.41 0 0 0 1.04 1.592 4.4 4.4 0 0 0 1.597 1.035c.572.221 1.227.372 2.185.414.958.042 1.266.052 3.71.047 2.443-.005 2.75-.016 3.71-.061.96-.046 1.611-.199 2.183-.423a4.411 4.411 0 0 0 1.592-1.04 4.41 4.41 0 0 0 1.035-1.597c.222-.572.372-1.227.414-2.184.042-.96.052-1.268.047-3.711-.005-2.444-.016-2.75-.061-3.71-.046-.96-.198-1.612-.423-2.184a4.418 4.418 0 0 0-1.04-1.592 4.4 4.4 0 0 0-1.597-1.035c-.572-.221-1.227-.372-2.185-.414-.958-.041-1.266-.052-3.71-.047-2.444.005-2.75.015-3.71.062m.105 16.27c-.878-.038-1.354-.184-1.672-.306a2.802 2.802 0 0 1-1.036-.671 2.772 2.772 0 0 1-.675-1.034c-.124-.317-.272-.793-.313-1.67-.045-.95-.054-1.234-.06-3.637-.004-2.403.005-2.687.046-3.636.038-.877.184-1.354.306-1.671.162-.421.357-.72.672-1.036a2.778 2.778 0 0 1 1.033-.675c.317-.124.793-.272 1.67-.313.95-.045 1.234-.054 3.637-.06 2.402-.005 2.687.004 3.637.046.876.038 1.354.183 1.67.306.421.162.72.357 1.037.671.316.315.511.613.675 1.034.124.317.271.792.313 1.67.045.95.055 1.234.06 3.636.004 2.402-.004 2.688-.046 3.636-.038.878-.184 1.354-.306 1.672a2.79 2.79 0 0 1-.672 1.036 2.78 2.78 0 0 1-1.033.675c-.317.124-.794.271-1.67.313-.95.045-1.234.054-3.637.06-2.403.005-2.687-.005-3.636-.046M15.715 7.19a1.08 1.08 0 1 0 2.16-.004 1.08 1.08 0 0 0-2.16.004m-8.336 4.819a4.62 4.62 0 1 0 9.242-.018 4.62 4.62 0 0 0-9.242.018M9 12.006a3 3 0 1 1 6-.012 3 3 0 0 1-6 .012" })), rn = m(on), ln = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z" })), hn = m(ln), mn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z" })), dn = m(mn), vn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" })), gn = m(vn), un = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" })), wn = m(un), pn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" })), fn = m(pn), Mn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z" })), xn = m(Mn), En = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ t.createElement("path", { d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 11.7V16h-4v-2.3C8.48 12.63 7 11.53 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.49-1.51 3.65-3 4.7z" })), bn = m(En), zn = (e) => /* @__PURE__ */ t.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.667 3A1.322 1.322 0 0 1 21 4.298V19.7a1.323 1.323 0 0 1-1.333 1.3H4.328A1.32 1.32 0 0 1 3 19.701V4.3A1.32 1.32 0 0 1 4.328 3h15.339Zm-4.898 6.1a2.834 2.834 0 0 0-2.55 1.403h-.036V9.316H9.6V18h2.692v-4.296c0-1.133.214-2.23 1.616-2.23 1.382 0 1.4 1.296 1.4 2.303V18H18v-4.764c0-2.338-.503-4.136-3.231-4.136Zm-6.86.216H5.213V18h2.694V9.316ZM6.561 5A1.57 1.57 0 0 0 5 6.565a1.57 1.57 0 0 0 1.562 1.564l.142-.006a1.572 1.572 0 0 0 1.42-1.558l-.006-.142A1.572 1.572 0 0 0 6.562 5Z" })), Sn = m(zn), _n = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" })), Cn = m(_n), Nn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11A4.991 4.991 0 0 0 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z" })), yn = m(Nn), Ln = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" })), kn = m(Ln), $n = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z" })), Hn = m($n), Vn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07L12 12.9z" }), /* @__PURE__ */ t.createElement("path", { d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52z" })), Bn = m(Vn), On = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m19.77 7.23.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" })), An = m(On), Dn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" })), Tn = m(Dn), Fn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z" })), Pn = m(Fn), Rn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9.17 16.83a4.008 4.008 0 0 0 5.66 0 4.008 4.008 0 0 0 0-5.66l-5.66 5.66zM18 2.01 6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" })), Un = m(Rn), Yn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z" })), Wn = m(Yn), Kn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })), In = m(Kn), Zn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z" })), Gn = m(Zn), jn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z" })), qn = m(jn), Qn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm2.5 11.59.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59z" })), Jn = m(Qn), Xn = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" })), ec = m(Xn), tc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z" })), sc = m(tc), ac = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z" })), nc = m(ac), cc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" })), ic = m(cc), oc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z" })), rc = m(oc), lc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ t.createElement("path", { d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z" })), hc = m(lc), mc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z" })), dc = m(mc), vc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" })), gc = m(vc), uc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" })), wc = m(uc), pc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" })), fc = m(pc), Mc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" })), xc = m(Mc), Ec = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m20.5 3-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z" })), bc = m(Ec), zc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6A2.5 2.5 0 0 0 2 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5A2.5 2.5 0 0 0 19.5 6zm-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9zm17 0c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1V9zm-9.81 1.48c-.44.26-.96.56-1.69.76V10.2c.48-.17.84-.38 1.18-.58C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.34.2.71.42 1.2.59v1.04c-.75-.21-1.26-.51-1.71-.78-.46-.27-.8-.47-1.29-.47s-.84.2-1.31.48z" })), Sc = m(zc), _c = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm6 11h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z" })), Cc = m(_c), Nc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" })), yc = m(Nc), Lc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-4 1.8-1 .6-1-.6V3h2v9.23z" })), kc = m(Lc), $c = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" })), Hc = m($c), Vc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" })), Bc = m(Vc), Oc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" })), Ac = m(Oc), Dc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" })), Tc = m(Dc), Fc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })), Pc = m(Fc), Rc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11.41 7.41 10 6l-6 6 6 6 1.41-1.41L6.83 12zm8 0L18 6l-6 6 6 6 1.41-1.41L14.83 12z" })), Uc = m(Rc), Yc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m14 6-1.41 1.41L17.17 12l-4.58 4.59L14 18l6-6zM6 6 4.59 7.41 9.17 12l-4.58 4.59L6 18l6-6z" })), Wc = m(Yc), Kc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z" })), Ic = m(Kc), Zc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" })), Gc = m(Zc), jc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M7.58 4.08 6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 0 1 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 0 1 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z" })), qc = m(jc), Qc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" })), Jc = m(Qc), Xc = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 18.69 7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z" })), ei = m(Xc), ti = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.96v-4H21z" })), si = m(ti), ai = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" })), ni = m(ai), ci = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" })), ii = m(ci), oi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 4.5, cy: 9.5, r: 2.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 9, cy: 5.5, r: 2.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 15, cy: 5.5, r: 2.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 19.5, cy: 9.5, r: 2.5 }), /* @__PURE__ */ t.createElement("path", { d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z" })), ri = m(oi), li = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" })), hi = m(li), mi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 12, cy: 12, r: 3.2 }), /* @__PURE__ */ t.createElement("path", { d: "M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" })), di = m(mi), vi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" })), gi = m(vi), ui = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 12, cy: 19, r: 2 }), /* @__PURE__ */ t.createElement("path", { d: "M10 3h4v12h-4z" })), wi = m(ui), pi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" })), fi = m(pi), Mi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z" })), xi = m(Mi), Ei = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })), bi = m(Ei), zi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17.51 7A5.62 5.62 0 0 0 7 5.51a4.5 4.5 0 0 0 .49 9h9.75A3.74 3.74 0 0 0 17.51 7ZM4.076 20.774 6.08 15.77l1.857.743-2.003 5.004zm4.998-.002 2.003-5.004 1.856.743-2.002 5.004zm4.998.008 2.002-5.004 1.857.743-2.002 5.004z" })), Si = m(zi), _i = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58A6.95 6.95 0 0 0 18 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58A2.01 2.01 0 0 0 2 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 16 9.43V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 21 21.43V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 11 21.43V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z" })), Ci = m(_i), Ni = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" })), yi = m(Ni), Li = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 13H5v-2h14v2z" })), ki = m(Li), $i = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z" })), Hi = m($i), Vi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z" })), Bi = m(Vi), Oi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 6.18, cy: 17.82, r: 2.18 }), /* @__PURE__ */ t.createElement("path", { d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z" })), Ai = m(Oi), Di = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11 5h2v14h-2V5zm-6 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 1 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85zM19 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 15 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85z" })), Ti = m(Di), Fi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5zm4 8.5a2.5 2.5 0 0 0 2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 0 0 2.5 2.5zM13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2zm3-2v10H4V12c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 2.99 1.01l-1.43 1.43C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91z" })), Pi = m(Fi), Ri = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" })), Ui = m(Ri), Yi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("g", { "data-name": "Severe Weather" }, /* @__PURE__ */ t.createElement("path", { d: "M4.05 17.73 12 4l8 13.85A5 5 0 0 0 19.2 8a7.49 7.49 0 0 0-14-2 6 6 0 0 0-1.15 11.73Z" }), /* @__PURE__ */ t.createElement("path", { d: "M12 7 3.34 22h17.32Zm0 13.4a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM11 17v-4.6h2V17Z" }))), Wi = m(Yi), Ki = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }), /* @__PURE__ */ t.createElement("path", { d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" })), Ii = m(Ki), Zi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3 1 9l11 6 9-4.91V17h2V9L12 3z" })), Gi = m(Zi), ji = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.8 18.4 14 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81H9.04c-.42 0-.65.48-.39.81L10 6.5v4.17L4.2 18.4c-.49.66-.02 1.6.8 1.6h14c.82 0 1.29-.94.8-1.6z" })), qi = m(ji), Qi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" })), Ji = m(Qi), Xi = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" })), eo = m(Xi), to = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" })), so = m(to), ao = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-3.5c.73 0 1.39.19 1.97.53.12-.14.86-.98 1.01-1.14A5.39 5.39 0 0 0 12 15c-1.11 0-2.13.33-2.99.88.97 1.09.01.02 1.01 1.14.59-.33 1.25-.52 1.98-.52z" })), no = m(ao), co = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9 15.5h6v1H9v-1z" }), /* @__PURE__ */ t.createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })), io = m(co), oo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15a5.49 5.49 0 0 0 5.95-.01c-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z" })), ro = m(oo), lo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z" })), ho = m(lo), mo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z" })), vo = m(mo), go = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" })), uo = m(go), wo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" })), po = m(wo), fo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" })), Mo = m(fo), xo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m17.21 9-4.38-6.56a.993.993 0 0 0-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" })), Eo = m(xo), bo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m20.76 14.07-.66-1.34-2.88 1.42L13.5 12l3.72-2.15 2.88 1.42.66-1.34-1.97-.98 2.25-1.3-.75-1.3-2.25 1.3.14-2.2-1.5-.1-.21 3.2-3.72 2.15V6.4l2.67-1.78-.84-1.24-1.83 1.22V2h-1.5v2.6L9.42 3.38l-.84 1.24 2.67 1.78v4.3L7.53 8.55l-.21-3.2-1.5.1.14 2.2-2.25-1.3-.75 1.3 2.25 1.3-1.97.98.66 1.34 2.88-1.42L10.5 12l-3.72 2.15-2.88-1.42-.66 1.34 1.97.98-2.25 1.3.75 1.3 2.25-1.3-.14 2.2 1.5.1.21-3.2 3.72-2.15v4.3l-2.67 1.78.84 1.24 1.83-1.22V22h1.5v-2.6l1.83 1.22.84-1.24-2.67-1.78v-4.3l3.72 2.15.21 3.2 1.5-.1-.14-2.2 2.25 1.3.75-1.3-2.25-1.3 1.97-.98z" })), zo = m(bo), So = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m9.12 5-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 0 0 0-2.5H12v-1h7.75a1.25 1.25 0 0 0 0-2.5H12v-1h8.75a1.25 1.25 0 0 0 0-2.5H12v-1h6.75a1.25 1.25 0 0 0 0-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 0 0-.12-1.23C10.22 6.12 9.12 5 9.12 5zM14 6.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75m0-1.5c-1.24 0-2.25 1.01-2.25 2.25S12.76 9.25 14 9.25 16.25 8.24 16.25 7 15.24 4.75 14 4.75zm5.75.75c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m0-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM16.5 1c-.83 0-1.5.67-1.5 1.5S15.67 4 16.5 4 18 3.33 18 2.5 17.33 1 16.5 1z" })), _o = m(So), Co = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M4 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 2 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM18 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 14 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM22 17l-4-4v3H6v-3l-4 4 4 4v-3h12v3l4-4z" })), No = m(Co), yo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.17 15 13 17.17V6.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 11 6.83v10.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z" })), Lo = m(yo), ko = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z" })), $o = m(ko), Ho = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" })), Vo = m(Ho), Bo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" })), Oo = m(Bo), Ao = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" })), Do = m(Ao), To = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z" })), Fo = m(To), Po = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12-2.78 1.15a4.982 4.982 0 0 0-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 0 0-2.98 2.97L4.54 9.13a7.984 7.984 0 0 1 4.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 0 0 2.97 2.96l-1.17 2.78a7.996 7.996 0 0 1-4.58-4.59zm10.34 4.59-1.15-2.78a4.978 4.978 0 0 0 2.95-2.97l2.78 1.17a8.007 8.007 0 0 1-4.58 4.58z" })), Ro = m(Po), Uo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z" }), /* @__PURE__ */ t.createElement("circle", { cx: 9, cy: 13, r: 1 }), /* @__PURE__ */ t.createElement("circle", { cx: 15, cy: 13, r: 1 }), /* @__PURE__ */ t.createElement("path", { d: "M18 11.03A6.04 6.04 0 0 0 12.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 0 0 4.86-5.89c1.31 2.63 4 4.44 7.12 4.47z" })), Yo = m(Uo), Wo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z" })), Ko = m(Wo), Io = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M22 4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V4zM2.17 11.12c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15z" })), Zo = m(Io), Go = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 0 0-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84A2.34 2.34 0 0 0 9.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z" })), jo = m(Go), qo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9 1h6v2H9zm10.03 6.39 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4a9 9 0 0 0-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61zM13 14h-2V8h2v6z" })), Qo = m(qo), Jo = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" })), Xo = m(Jo), e0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" })), t0 = m(e0), s0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z" })), a0 = m(s0), n0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13 16v-2h2.77c.08-.32.16-.65.23-1 1.19-5.95 4-6 4-10H4a10.35 10.35 0 0 0 .48 3H8v2H5.26c.32.69.68 1.36 1 2H10v2H7.51A13.86 13.86 0 0 1 9 15a6.24 6.24 0 0 1-1 6l1 1c2.82-1.54 4.85-3.09 6.1-6Z" })), c0 = m(n0), i0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m12.87 15.07-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z" })), o0 = m(i0), r0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z" })), l0 = m(r0), h0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" })), m0 = m(h0), d0 = (e) => /* @__PURE__ */ t.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.912 7.925v.527A11.562 11.562 0 0 1 8.265 20.098 11.443 11.443 0 0 1 2 18.265c.328.017.657.017.985 0a8.132 8.132 0 0 0 5.093-1.698 4.092 4.092 0 0 1-3.786-2.852c.255.062.518.091.781.085.36-.002.72-.047 1.07-.136a4.109 4.109 0 0 1-3.21-4.024c.566.32 1.202.494 1.851.51a4.126 4.126 0 0 1-1.34-5.518 11.613 11.613 0 0 0 8.488 4.295 4.397 4.397 0 0 1-.119-.934 4.092 4.092 0 0 1 4.092-4.092 4.04 4.04 0 0 1 3.005 1.29 7.929 7.929 0 0 0 2.53-1c-.3.953-.94 1.763-1.8 2.274A7.725 7.725 0 0 0 22 5.803a8.489 8.489 0 0 1-2.088 2.122Z", fillRule: "evenodd" })), v0 = m(d0), g0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" })), u0 = m(g0), w0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M7.41 18.59 8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z" })), p0 = m(w0), f0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" })), M0 = m(f0), x0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z" })), E0 = m(x0), b0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z" })), z0 = m(b0), S0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m23 12-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z" })), _0 = m(S0), C0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" })), N0 = m(C0), y0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" })), L0 = m(y0), k0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" })), $0 = m(k0), H0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z" })), V0 = m(H0), B0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" })), O0 = m(B0), A0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.5 8A2.5 2.5 0 0 0 21 5.5C21 3.83 18.5 1 18.5 1S16 3.83 16 5.5A2.5 2.5 0 0 0 18.5 8zm-5 1c.83 0 1.5-.67 1.5-1.5 0-.84-1.5-2.5-1.5-2.5S12 6.66 12 7.5c0 .83.67 1.5 1.5 1.5zM9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 0 0 0-2.5H12v-1h7.75a1.25 1.25 0 0 0 0-2.5H12v-1h8.75a1.25 1.25 0 0 0 0-2.5H12v-1h6.75a1.25 1.25 0 0 0 0-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 0 0-.12-1.23C10.22 6.12 9.12 5 9.12 5z" })), D0 = m(A0), T0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m1 9 2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8 3 3 3-3a4.237 4.237 0 0 0-6 0zm-4-4 2 2a7.074 7.074 0 0 1 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" })), F0 = m(T0), P0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" })), R0 = m(P0), U0 = (e) => /* @__PURE__ */ t.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13.522 10.775 19.48 4h-1.412l-5.172 5.883L8.765 4H4l6.247 8.895L4 20h1.412l5.461-6.212L15.236 20H20l-6.478-9.225Zm-1.933 2.199-.633-.886L5.92 5.04h2.168l4.064 5.688.633.886 5.283 7.394H15.9l-4.311-6.034Z" })), Y0 = m(U0), W0 = (e) => /* @__PURE__ */ t.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.816 5.389a2.469 2.469 0 0 1 1.766 1.746c.291 1.598.43 3.22.417 4.843a25.867 25.867 0 0 1-.417 4.794 2.468 2.468 0 0 1-1.766 1.795c-2.593.318-5.204.46-7.816.429a58.411 58.411 0 0 1-7.816-.429 2.469 2.469 0 0 1-1.766-1.746 25.879 25.879 0 0 1-.417-4.843 25.85 25.85 0 0 1 .417-4.793 2.468 2.468 0 0 1 1.766-1.796c2.594-.3 5.205-.427 7.816-.379a58.413 58.413 0 0 1 7.816.379ZM9.95 9.046v5.864l5.233-2.932L9.95 9.046Z" })), K0 = m(W0), I0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }), /* @__PURE__ */ t.createElement("path", { d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" })), Z0 = m(I0), G0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m15 3 2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z" })), j0 = m(G0), q0 = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" })), Q0 = m(q0), h = (e) => {
  const s = (a) => {
    const {
      size: n,
      className: i,
      focusable: r = !1,
      role: o = "img",
      ...v
    } = a, u = {
      className: g(
        "usa-icon",
        {
          [`usa-icon--size-${n}`]: n !== void 0
        },
        i
      ),
      focusable: r,
      role: o,
      ...v
    };
    return o === "img" && !v["aria-hidden"] && !v["aria-label"] && !v["aria-labelledby"] && console.warn(
      "Icon with img role is missing an accessible label. https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Img_role#associated_wai-aria_roles_states_and_properties"
    ), /* @__PURE__ */ c(e, { ...u });
  };
  return s.displayName = e.displayName, s;
}, l = class l {
};
l.AccessibilityNew = h(Qt), l.AccessibleForward = h(Xt), l.AccountBalance = h(t1), l.AccountBox = h(a1), l.AccountCircle = h(c1), l.Add = h(o1), l.AddCircle = h(l1), l.AddCircleOutline = h(m1), l.Alarm = h(v1), l.AlternateEmail = h(u1), l.Announcement = h(p1), l.ArrowBack = h(M1), l.ArrowDownward = h(E1), l.ArrowDropDown = h(z1), l.ArrowDropUp = h(_1), l.ArrowForward = h(N1), l.ArrowUpward = h(L1), l.Api = h($1), l.Assessment = h(V1), l.AttachFile = h(O1), l.AttachMoney = h(D1), l.Autorenew = h(F1), l.Backpack = h(R1), l.Bathtub = h(Y1), l.Bedding = h(K1), l.Bookmark = h(Z1), l.BugReport = h(j1), l.Build = h(Q1), l.CalendarToday = h(X1), l.Campaign = h(ts), l.Camping = h(as), l.Cancel = h(cs), l.Chat = h(os), l.Check = h(ls), l.CheckBoxOutlineBlank = h(ms), l.CheckCircle = h(vs), l.CheckCircleOutline = h(us), l.Checkroom = h(ps), l.CleanHands = h(Ms), l.Clothes = h(Es), l.Close = h(zs), l.ClosedCaption = h(_s), l.Cloud = h(Ns), l.Code = h(Ls), l.Comment = h($s), l.ConnectWithoutContact = h(Vs), l.Construction = h(Os), l.ConstructionWorker = h(Ds), l.ContactPage = h(Fs), l.ContentCopy = h(Rs), l.Coronavirus = h(Ys), l.CreditCard = h(Ks), l.Deck = h(Zs), l.Delete = h(js), l.DeviceThermostat = h(Qs), l.Directions = h(Xs), l.DirectionsBike = h(ta), l.DirectionsBus = h(aa), l.DirectionsCar = h(ca), l.DirectionsWalk = h(oa), l.DoNotDisturb = h(la), l.DoNotTouch = h(ma), l.DragHandle = h(va), l.Eco = h(ua), l.Edit = h(pa), l.ElectricalServices = h(Ma), l.EmojiEvents = h(Ea), l.Error = h(za), l.ErrorOutline = h(_a), l.Event = h(Na), l.ExpandLess = h(La), l.ExpandMore = h($a), l.Facebook = h(Va), l.FastForward = h(Oa), l.FastRewind = h(Da), l.Favorite = h(Fa), l.FavoriteBorder = h(Ra), l.Fax = h(Ya), l.FileDownload = h(Ka), l.FilePresent = h(Za), l.FileUpload = h(ja), l.FilterAlt = h(Qa), l.FilterList = h(Xa), l.Fingerprint = h(t2), l.FirstPage = h(a2), l.Flag = h(c2), l.Flickr = h(o2), l.Flight = h(l2), l.Flooding = h(m2), l.Folder = h(v2), l.FolderOpen = h(u2), l.FormatQuote = h(p2), l.FormatSize = h(M2), l.Forum = h(E2), l.Github = h(z2), l.GridView = h(_2), l.GroupAdd = h(N2), l.Groups = h(L2), l.Hearing = h($2), l.Help = h(V2), l.HelpOutline = h(O2), l.HighlightOff = h(D2), l.History = h(F2), l.Home = h(R2), l.Hospital = h(Y2), l.Hotel = h(K2), l.HourglassEmpty = h(Z2), l.Hurricane = h(j2), l.Identification = h(Q2), l.Image = h(X2), l.Info = h(tn), l.InfoOutline = h(an), l.Insights = h(cn), l.Instagram = h(rn), l.Keyboard = h(hn), l.Label = h(dn), l.Language = h(gn), l.LastPage = h(wn), l.Launch = h(fn), l.Lightbulb = h(xn), l.LightbulbOutline = h(bn), l.LinkedIn = h(Sn), l.Link = h(Cn), l.LinkOff = h(yn), l.List = h(kn), l.LocalCafe = h(Hn), l.LocalFireDepartment = h(Bn), l.LocalGasStation = h(An), l.LocalGroceryStore = h(Tn), l.LocalHospital = h(Pn), l.LocalLaundryService = h(Un), l.LocalLibrary = h(Wn), l.LocalOffer = h(In), l.LocalParking = h(Gn), l.LocalPharmacy = h(qn), l.LocalPolice = h(Jn), l.LocalTaxi = h(ec), l.LocationCity = h(sc), l.LocationOn = h(nc), l.Lock = h(ic), l.LockOpen = h(rc), l.LockOutline = h(hc), l.Login = h(dc), l.Logout = h(gc), l.Loop = h(wc), l.Mail = h(fc), l.MailOutline = h(xc), l.Map = h(bc), l.Masks = h(Sc), l.MedicalServices = h(Cc), l.Menu = h(yc), l.MilitaryTech = h(kc), l.MoreHoriz = h(Hc), l.MoreVert = h(Bc), l.MyLocation = h(Ac), l.NavigateBefore = h(Tc), l.NavigateNext = h(Pc), l.NavigateFarBefore = h(Uc), l.NavigateFarNext = h(Wc), l.NearMe = h(Ic), l.Notifications = h(Gc), l.NotificationsActive = h(qc), l.NotificationsNone = h(Jc), l.NotificationsOff = h(ei), l.Park = h(si), l.People = h(ni), l.Person = h(ii), l.Pets = h(ri), l.Phone = h(hi), l.PhotoCamera = h(di), l.Print = h(gi), l.PriorityHigh = h(wi), l.Public = h(fi), l.PushPin = h(xi), l.RadioButtonUnchecked = h(bi), l.Rain = h(Si), l.ReduceCapacity = h(Ci), l.RemoveCircle = h(yi), l.Remove = h(ki), l.Report = h(Hi), l.Restaurant = h(Bi), l.RssFeed = h(Ai), l.SafetyDivider = h(Ti), l.Sanitizer = h(Pi), l.SaveAlt = h(Ui), l.SevereWeather = h(Wi), l.Schedule = h(Ii), l.School = h(Gi), l.Science = h(qi), l.Search = h(Ji), l.Security = h(eo), l.Send = h(so), l.SentimentDissatisfied = h(no), l.SentimentNeutral = h(io), l.SentimentSatisfied = h(ro), l.SentimentSatisfiedAlt = h(ho), l.SentimentVeryDissatisfied = h(vo), l.Settings = h(uo), l.Share = h(po), l.Shield = h(Mo), l.ShoppingBasket = h(Eo), l.Snow = h(zo), l.Soap = h(_o), l.SocialDistance = h(No), l.SortArrow = h(Lo), l.Spellcheck = h($o), l.Star = h(Vo), l.StarHalf = h(Oo), l.StarOutline = h(Do), l.Store = h(Fo), l.Support = h(Ro), l.SupportAgent = h(Yo), l.TextFields = h(Ko), l.ThumbDownAlt = h(Zo), l.ThumbUpAlt = h(jo), l.Timer = h(Qo), l.ToggleOff = h(Xo), l.ToggleOn = h(t0), l.Topic = h(a0), l.Tornado = h(c0), l.Translate = h(o0), l.TrendingDown = h(l0), l.TrendingUp = h(m0), l.Twitter = h(v0), l.Undo = h(u0), l.UnfoldLess = h(p0), l.UnfoldMore = h(M0), l.Update = h(E0), l.UploadFile = h(z0), l.Verified = h(_0), l.VerifiedUser = h(N0), l.Visibility = h(L0), l.VisibilityOff = h($0), l.VolumeOff = h(V0), l.Warning = h(O0), l.Wash = h(D0), l.Wifi = h(F0), l.Work = h(R0), l.X = h(Y0), l.Youtube = h(K0), l.ZoomIn = h(Z0), l.ZoomOutMap = h(j0), l.ZoomOut = h(Q0);
let ae = l;
const J0 = ({
  page: e,
  isCurrent: s,
  pathname: a,
  onClickPageNumber: n
}) => {
  const i = g("usa-pagination__button", {
    "usa-current": s
  });
  return /* @__PURE__ */ c(
    "li",
    {
      className: "usa-pagination__item usa-pagination__page-no",
      children: n ? /* @__PURE__ */ c(
        Se,
        {
          type: "button",
          unstyled: !0,
          "data-testid": "pagination-page-number",
          className: i,
          "aria-label": `Page ${e}`,
          "aria-current": s ? "page" : void 0,
          onClick: (r) => {
            n(r, e);
          },
          children: e
        }
      ) : /* @__PURE__ */ c(
        ue,
        {
          href: `${a}?page=${e}`,
          className: i,
          "aria-label": `Page ${e}`,
          "aria-current": s ? "page" : void 0,
          children: e
        }
      )
    },
    `pagination_page_${e}`
  );
}, X0 = () => /* @__PURE__ */ c(
  "li",
  {
    className: "usa-pagination__item usa-pagination__overflow",
    "aria-label": "ellipsis indicating non-visible pages",
    children: /* @__PURE__ */ c("span", { children: "…" })
  }
), El = ({
  pathname: e,
  totalPages: s,
  currentPage: a,
  className: n,
  maxSlots: i = 7,
  onClickPrevious: r,
  onClickNext: o,
  onClickPageNumber: v,
  ...d
}) => {
  const u = g("usa-pagination", n), w = a === 1, f = s ? a === s : !1, _ = s ? s > i : !0, k = Math.round(i / 2), b = !!(s && s - a >= k), M = _ && a > k, B = b || !s, x = _ || !s ? [a] : Array.from({ length: s }).map((N, A) => A + 1);
  if (_) {
    const N = w ? 0 : M ? 2 : 1, A = f ? 0 : B ? 2 : 1, V = i - 1 - (N + A);
    let E = 0, S = 0;
    M && B ? (E = Math.round((V - 1) / 2), S = V - E) : M ? (S = (s || 0) - a - 1, S = S < 0 ? 0 : S, E = V - S) : B && (E = a - 2, E = E < 0 ? 0 : E, S = V - E);
    let L = 1;
    for (; E > 0; )
      x.unshift(a - L), L++, E--;
    for (L = 1; S > 0; )
      x.push(a + L), L++, S--;
    M && x.unshift("overflow"), a !== 1 && x.unshift(1), B && x.push("overflow"), s && a !== s && x.push(s);
  }
  const $ = !w && a - 1, p = !f && a + 1;
  return /* @__PURE__ */ c("nav", { "aria-label": "Pagination", className: u, ...d, children: /* @__PURE__ */ z("ul", { className: "usa-pagination__list", children: [
    $ && /* @__PURE__ */ c("li", { className: "usa-pagination__item usa-pagination__arrow", children: r ? /* @__PURE__ */ z(
      Se,
      {
        type: "button",
        unstyled: !0,
        className: "usa-pagination__link usa-pagination__previous-page",
        "aria-label": "Previous page",
        "data-testid": "pagination-previous",
        onClick: r,
        children: [
          /* @__PURE__ */ c(ae.NavigateBefore, { "aria-hidden": !0 }),
          /* @__PURE__ */ c("span", { className: "usa-pagination__link-text", children: "Previous" })
        ]
      }
    ) : /* @__PURE__ */ z(
      ue,
      {
        href: `${e}?page=${$}`,
        className: "usa-pagination__link usa-pagination__previous-page",
        "aria-label": "Previous page",
        children: [
          /* @__PURE__ */ c(ae.NavigateBefore, { "aria-hidden": !0 }),
          /* @__PURE__ */ c("span", { className: "usa-pagination__link-text", children: "Previous" })
        ]
      }
    ) }),
    x.map(
      (N, A) => N === "overflow" ? /* @__PURE__ */ c(X0, {}, `pagination_overflow_${A}`) : /* @__PURE__ */ c(
        J0,
        {
          page: N,
          pathname: e,
          isCurrent: N === a,
          onClickPageNumber: v
        },
        `pagination_page_${N}`
      )
    ),
    p && /* @__PURE__ */ c("li", { className: "usa-pagination__item usa-pagination__arrow", children: o ? /* @__PURE__ */ z(
      Se,
      {
        type: "button",
        unstyled: !0,
        className: "usa-pagination__link usa-pagination__next-page",
        "aria-label": "Next page",
        "data-testid": "pagination-next",
        onClick: o,
        children: [
          /* @__PURE__ */ c("span", { className: "usa-pagination__link-text", children: "Next" }),
          /* @__PURE__ */ c(ae.NavigateNext, { "aria-hidden": !0 })
        ]
      }
    ) : /* @__PURE__ */ z(
      ue,
      {
        href: `${e}?page=${p}`,
        className: "usa-pagination__link usa-pagination__next-page",
        "aria-label": "Next page",
        children: [
          /* @__PURE__ */ c("span", { className: "usa-pagination__link-text", children: "Next" }),
          /* @__PURE__ */ c(ae.NavigateNext, { "aria-hidden": !0 })
        ]
      }
    ) })
  ] }) });
}, er = ({
  children: e,
  divProps: s,
  className: a,
  ...n
}) => {
  const i = g("usa-banner", a), { className: r, ...o } = s || {}, v = g("usa-accordion", r);
  return /* @__PURE__ */ c("section", { className: i, ...n, children: /* @__PURE__ */ c("div", { className: v, ...o, children: e }) });
}, tr = ({
  isOpen: e,
  children: s,
  className: a,
  spanProps: n,
  ...i
}) => {
  const r = g(
    "usa-accordion__button usa-banner__button",
    a
  ), { className: o, ...v } = n || {}, d = g("usa-banner__button-text", o);
  return /* @__PURE__ */ c(
    "button",
    {
      type: "button",
      className: r,
      "aria-expanded": e,
      ...i,
      children: /* @__PURE__ */ c("span", { className: d, ...v, children: s })
    }
  );
}, sr = ({
  children: e,
  isOpen: s,
  className: a,
  ...n
}) => {
  const i = g(
    "usa-banner__content usa-accordion__content",
    a
  );
  return /* @__PURE__ */ c("div", { className: i, hidden: !s, ...n, children: e });
}, ar = ({
  alt: e,
  className: s,
  ...a
}) => {
  const n = g("usa-banner__header-flag", s);
  return /* @__PURE__ */ c("img", { className: n, alt: e, ...a });
}, ht = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-banner__guidance", s);
  return /* @__PURE__ */ c("div", { className: n, ...a, children: e });
}, nr = ({
  children: e,
  isOpen: s,
  flagImg: a,
  innerDivProps: n,
  headerText: i,
  headerTextProps: r,
  headerActionText: o,
  headerActionProps: v,
  className: d,
  ...u
}) => {
  const w = g(
    "usa-banner__header",
    {
      "usa-banner__header--expanded": s
    },
    d
  ), { className: f, ..._ } = n || {}, k = g("usa-banner__inner", f), { className: b, ...M } = r || {}, B = g(
    "usa-banner__header-text",
    b
  ), { className: x, ...$ } = v || {}, p = g(
    "usa-banner__header-action",
    x
  );
  return /* @__PURE__ */ c("header", { className: w, ...u, children: /* @__PURE__ */ z(
    "div",
    {
      className: k,
      ..._,
      "data-testid": "banner-header-inner-div",
      children: [
        a && /* @__PURE__ */ c("div", { className: "grid-col-auto", "data-testid": "banner-header-flag-div", children: a }),
        /* @__PURE__ */ z(
          "div",
          {
            className: "grid-col-fill tablet:grid-col-auto",
            "aria-hidden": !0,
            "data-testid": "banner-header-grid-div",
            children: [
              /* @__PURE__ */ c("p", { className: B, ...M, children: i }),
              /* @__PURE__ */ c(
                "p",
                {
                  className: p,
                  "aria-hidden": "true",
                  ...$,
                  children: o
                }
              )
            ]
          }
        ),
        e
      ]
    }
  ) });
}, mt = ({
  src: e,
  alt: s,
  className: a,
  ...n
}) => {
  const i = g("usa-banner__icon usa-media-block__img", a);
  return /* @__PURE__ */ c(
    "img",
    {
      className: i,
      src: e,
      alt: s,
      "aria-hidden": "true",
      ...n
    }
  );
}, cr = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAsBAMAAAAncaPMAAAAAXNSR0IArs4c6QAAABtQTFRF////4EAg2z8g2z8f2z4f2j4fHjSyHjOxHTOxQEYPwgAAAIdJREFUeNrNkUENxDAMBEOhFJaCKZiCKZhCKBj2ebV3rdR71+pIq+Qxj1GyqjJ3U8VlHkc07hFm0awBYe91juq6MSI0yhSAEgkzJ4TMKiXyzFw3pgR9lmIBJlqj2AmBedf+IycExmlKZVzvZEJ4A0oBrjBl/m6PCy95B3fFAN6YuQPxhbcB4QMkEj04wQXD5wAAAABJRU5ErkJggg==", ir = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%3e%3ctitle%3eicon-dot-gov%3c/title%3e%3cpath%20fill='%232378C3'%20fill-rule='evenodd'%20d='m32%200c17.7%200%2032%2014.3%2032%2032s-14.3%2032-32%2032-32-14.3-32-32%2014.3-32%2032-32zm0%201.2c-17%200-30.8%2013.8-30.8%2030.8s13.8%2030.8%2030.8%2030.8%2030.8-13.8%2030.8-30.8-13.8-30.8-30.8-30.8zm11.4%2038.9c.5%200%20.9.4.9.8v1.6h-24.6v-1.6c0-.5.4-.8.9-.8zm-17.1-12.3v9.8h1.6v-9.8h3.3v9.8h1.6v-9.8h3.3v9.8h1.6v-9.8h3.3v9.8h.8c.5%200%20.9.4.9.8v.8h-21.4v-.8c0-.5.4-.8.9-.8h.8v-9.8zm5.7-8.2%2012.3%204.9v1.6h-1.6c0%20.5-.4.8-.9.8h-19.6c-.5%200-.9-.4-.9-.8h-1.6v-1.6s12.3-4.9%2012.3-4.9z'/%3e%3c/svg%3e", or = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%3e%3ctitle%3eicon-https%3c/title%3e%3cpath%20fill='%23719F2A'%20fill-rule='evenodd'%20d='M32%200c17.673%200%2032%2014.327%2032%2032%200%2017.673-14.327%2032-32%2032C14.327%2064%200%2049.673%200%2032%200%2014.327%2014.327%200%2032%200zm0%201.208C14.994%201.208%201.208%2014.994%201.208%2032S14.994%2062.792%2032%2062.792%2062.792%2049.006%2062.792%2032%2049.006%201.208%2032%201.208zm0%2018.886a7.245%207.245%200%200%201%207.245%207.245v3.103h.52c.86%200%201.557.698%201.557%201.558v9.322c0%20.86-.697%201.558-1.557%201.558h-15.53c-.86%200-1.557-.697-1.557-1.558V32c0-.86.697-1.558%201.557-1.558h.52V27.34A7.245%207.245%200%200%201%2032%2020.094zm0%203.103a4.142%204.142%200%200%200-4.142%204.142v3.103h8.284V27.34A4.142%204.142%200%200%200%2032%2023.197z'/%3e%3c/svg%3e", rr = (e, s) => {
  switch (e) {
    case "english":
      return {
        header: "An official website of the United States government",
        ariaLabel: "Official website of the United States government",
        headerAction: "Here’s how you know",
        tldSectionHeader: `Official websites use ${s}`,
        tldSectionContent: (() => {
          switch (s) {
            case ".gov":
              return /* @__PURE__ */ z(se, { children: [
                "A ",
                /* @__PURE__ */ c("strong", { children: ".gov" }),
                " website belongs to an official government organization in the United States."
              ] });
            case ".mil":
              return /* @__PURE__ */ z(se, { children: [
                "A ",
                /* @__PURE__ */ c("strong", { children: ".mil" }),
                " website belongs to an official U.S. Department of Defense organization."
              ] });
          }
        })(),
        httpsSectionHeader: `Secure ${s} websites use HTTPS`,
        httpsSectionContent: /* @__PURE__ */ z(se, { children: [
          "A",
          " ",
          /* @__PURE__ */ z("strong", { children: [
            "lock (",
            /* @__PURE__ */ c(ae.Lock, { "aria-label": "Locked padlock icon" }),
            ")"
          ] }),
          " ",
          "or ",
          /* @__PURE__ */ c("strong", { children: "https://" }),
          " means you’ve safely connected to the",
          " ",
          s,
          " website. Share sensitive information only on official, secure websites."
        ] })
      };
    case "spanish":
      return {
        header: "Un sitio oficial del Gobierno de Estados Unidos",
        ariaLabel: "Un sitio oficial del Gobierno de Estados Unidos",
        headerAction: "Así es como usted puede verificarlo",
        tldSectionHeader: `Los sitios web oficiales usan ${s}`,
        tldSectionContent: (() => {
          switch (s) {
            case ".gov":
              return /* @__PURE__ */ z(se, { children: [
                "Un sitio web ",
                /* @__PURE__ */ c("strong", { children: ".gov" }),
                " pertenece a una organización oficial del Gobierno de Estados Unidos."
              ] });
            case ".mil":
              return /* @__PURE__ */ z(se, { children: [
                "Un sitio web ",
                /* @__PURE__ */ c("strong", { children: ".mil" }),
                " pertenece a una organización oficial del Departamento de Defensa de EE. UU."
              ] });
          }
        })(),
        httpsSectionHeader: `Los sitios web seguros ${s} usan HTTPS`,
        httpsSectionContent: /* @__PURE__ */ z(se, { children: [
          "Un",
          " ",
          /* @__PURE__ */ z("strong", { children: [
            "candado (",
            /* @__PURE__ */ c(ae.Lock, { "aria-label": "Icono de candado cerrado" }),
            ")"
          ] }),
          " ",
          "o ",
          /* @__PURE__ */ c("strong", { children: "https://" }),
          " significa que usted se conectó de forma segura a un sitio web ",
          s,
          ". Comparta información sensible sólo en sitios web oficiales y seguros."
        ] })
      };
  }
}, bl = ({
  tld: e = ".gov",
  language: s = "english",
  className: a,
  ...n
}) => {
  const [i, r] = F(!1), {
    header: o,
    ariaLabel: v,
    headerAction: d,
    httpsSectionHeader: u,
    httpsSectionContent: w,
    tldSectionHeader: f,
    tldSectionContent: _
  } = rr(s, e);
  return /* @__PURE__ */ z(
    er,
    {
      className: a,
      "data-testid": "govBanner",
      "aria-label": v,
      ...n,
      children: [
        /* @__PURE__ */ c(
          nr,
          {
            isOpen: i,
            flagImg: /* @__PURE__ */ c(ar, { src: cr, "aria-hidden": !0, alt: "" }),
            headerText: o,
            headerActionText: d,
            children: /* @__PURE__ */ c(
              tr,
              {
                isOpen: i,
                "aria-controls": "gov-banner",
                onClick: () => {
                  r((k) => !k);
                },
                children: d
              }
            )
          }
        ),
        /* @__PURE__ */ c(sr, { id: "gov-banner", isOpen: i, children: /* @__PURE__ */ z("div", { className: "grid-row grid-gap-lg", children: [
          /* @__PURE__ */ z(ht, { className: "tablet:grid-col-6", children: [
            /* @__PURE__ */ c(mt, { src: ir, alt: "" }),
            /* @__PURE__ */ c(rt, { children: /* @__PURE__ */ z("p", { children: [
              /* @__PURE__ */ c("strong", { children: f }),
              /* @__PURE__ */ c("br", {}),
              _
            ] }) })
          ] }),
          /* @__PURE__ */ z(ht, { className: "tablet:grid-col-6", children: [
            /* @__PURE__ */ c(mt, { src: or, alt: "" }),
            /* @__PURE__ */ c(rt, { children: /* @__PURE__ */ z("p", { children: [
              /* @__PURE__ */ c("strong", { children: u }),
              /* @__PURE__ */ c("br", {}),
              w
            ] }) })
          ] })
        ] }) })
      ]
    }
  );
}, zl = ({
  children: e,
  className: s,
  condensed: a,
  ...n
}) => {
  const i = g(
    "usa-collection",
    { "usa-collection--condensed": a },
    s
  );
  return /* @__PURE__ */ c("ul", { className: i, "data-testid": "collection", ...n, children: e });
}, Sl = ({
  className: e,
  children: s,
  variantComponent: a,
  ...n
}) => {
  const i = g("usa-collection__item", e);
  return /* @__PURE__ */ z("li", { className: i, ...n, children: [
    a,
    /* @__PURE__ */ c("div", { className: "usa-collection__body", children: s })
  ] });
}, _l = ({
  headingLevel: e,
  className: s,
  children: a,
  ...n
}) => {
  const i = e, r = g("usa-collection__heading", s);
  return /* @__PURE__ */ c(i, { className: r, ...n, children: a });
}, Cl = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-collection__description", e);
  return /* @__PURE__ */ c("p", { className: n, ...a, children: s });
}, Nl = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-collection__meta", e);
  return /* @__PURE__ */ c("ul", { className: n, ...a, children: s });
}, yl = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-collection__meta-item", e);
  return /* @__PURE__ */ c("li", { className: n, ...a, children: s });
}, Ll = ({
  className: e,
  children: s,
  tagStyle: a,
  ...n
}) => {
  const i = g(
    "usa-collection__meta-item",
    "usa-tag",
    { "usa-tag--new": a === "new" },
    e
  );
  return /* @__PURE__ */ c("li", { className: i, ...n, children: s });
}, kl = ({
  className: e,
  src: s,
  alt: a,
  ...n
}) => {
  const i = g("usa-collection__img", e);
  return /* @__PURE__ */ c("img", { className: i, src: s, alt: a, ...n });
}, lr = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], $l = ({
  datetime: e
}) => {
  const s = new Date(e);
  return s && s.getTime && isNaN(s.getTime()) ? /* @__PURE__ */ c(se, {}) : /* @__PURE__ */ c(
    "div",
    {
      className: "usa-collection__calendar-date",
      "data-testid": "collection-calendar-date",
      children: /* @__PURE__ */ z("time", { dateTime: e, children: [
        /* @__PURE__ */ c("span", { className: "usa-collection__calendar-date-month", children: lr[s.getMonth()] }),
        /* @__PURE__ */ c("span", { className: "usa-collection__calendar-date-day", children: s.getDate() })
      ] })
    }
  );
};
function hr(e) {
  return "asCustom" in e;
}
function dt(e, s) {
  return g(
    {
      "grid-container": !s,
      [`grid-container-${s}`]: !!s
    },
    e
  );
}
function Hl(e) {
  if (hr(e)) {
    const { className: s, containerSize: a, asCustom: n, children: i, ...r } = e, o = r, v = dt(s, a);
    return ze.createElement(
      n,
      {
        "data-testid": "gridContainer",
        className: v,
        ...o
      },
      i
    );
  } else {
    const { className: s, containerSize: a, children: n, ...i } = e, r = dt(s, a);
    return /* @__PURE__ */ c(
      "div",
      {
        "data-testid": "gridContainer",
        className: r,
        ...i,
        children: n
      }
    );
  }
}
const tt = {
  mobile: "mobile",
  mobileLg: "mobile-lg",
  tablet: "tablet",
  tabletLg: "tablet-lg",
  desktop: "desktop",
  desktopLg: "desktop-lg",
  widescreen: "widescreen"
};
function mr(e) {
  return "asCustom" in e;
}
const Fe = (e = {}, s) => {
  const a = s ? `${tt[s]}:` : "", { row: n, col: i, gap: r, offset: o } = e;
  return g({
    [`${a}grid-row`]: n,
    [`${a}grid-gap`]: r === !0,
    [`${a}grid-gap-${r}`]: r !== !0 && !!r,
    [`${a}grid-col`]: i === !0,
    [`${a}grid-col-${i}`]: i !== !0 && !!i,
    [`${a}grid-offset-${o}`]: !!o
  });
}, dr = (e) => {
  let s = Fe(e);
  return Object.keys(tt).forEach((a) => {
    const n = a;
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      const i = e[n];
      s = g(s, Fe(i, n));
    }
  }), s;
};
function Vl(e) {
  const {
    children: s,
    className: a,
    row: n,
    col: i,
    gap: r,
    offset: o,
    mobile: v,
    mobileLg: d,
    tablet: u,
    tabletLg: w,
    desktop: f,
    desktopLg: _,
    widescreen: k,
    ...b
  } = e, M = {
    row: n,
    col: i,
    gap: r,
    offset: o
  }, B = {
    mobile: v,
    mobileLg: d,
    tablet: u,
    tabletLg: w,
    desktop: f,
    desktopLg: _,
    widescreen: k
  };
  let x = Fe(M);
  if (Object.keys(tt).forEach(($) => {
    const p = $;
    if (Object.prototype.hasOwnProperty.call(B, p)) {
      const N = e[p];
      x = g(x, Fe(N, p));
    }
  }), x = g(x, a), mr(b)) {
    const { asCustom: $, ...p } = b, N = p;
    return ze.createElement(
      $,
      {
        className: x,
        ...N
      },
      s
    );
  } else
    return /* @__PURE__ */ c("div", { className: x, "data-testid": "grid", ...b, children: s });
}
const Ve = _e(
  (e, s) => {
    const {
      id: a,
      name: n,
      type: i,
      className: r,
      validationStatus: o,
      inputSize: v,
      inputRef: d,
      ...u
    } = e, b = g(
      "usa-input",
      {
        "usa-input--error": o === "error",
        "usa-input--success": o === "success",
        "usa-input--small": v === "small",
        "usa-input--medium": v === "medium"
      },
      r
    );
    return /* @__PURE__ */ c(
      "input",
      {
        "data-testid": "textInput",
        className: b,
        id: a,
        name: n,
        type: i,
        ref: d || s,
        ...u
      }
    );
  }
);
Ve.displayName = "TextInput";
const vr = ({
  id: e,
  name: s,
  className: a,
  error: n,
  success: i,
  children: r,
  inputRef: o,
  ...v
}) => {
  const d = g(
    "usa-textarea",
    {
      "usa-input--error": n,
      "usa-input--success": i
    },
    a
  );
  return /* @__PURE__ */ c(
    "textarea",
    {
      "data-testid": "textarea",
      className: d,
      id: e,
      name: s,
      ref: o,
      ...v,
      children: r
    }
  );
}, gr = (e) => Array.from(e).length, ur = (e, s) => {
  const a = `${s} characters allowed`, n = "$0 characters left", i = "$0 character left", r = "$0 character over limit", o = "$0 characters over limit", v = s - e;
  switch (v) {
    case s:
      return a;
    case 1:
      return i.replace("$0", "1");
    case -1:
      return r.replace("$0", "1");
    default:
      return v >= 0 ? n.replace("$0", v.toString()) : o.replace("$0", Math.abs(v).toString());
  }
}, Bl = ({
  id: e,
  name: s,
  className: a,
  maxLength: n,
  value: i = "",
  defaultValue: r = "",
  isTextArea: o = !1,
  getCharacterCount: v = gr,
  getMessage: d = ur,
  ...u
}) => {
  const w = v(i || r), [f, _] = F(w), [k, b] = F(d(w, n)), [M, B] = F(w < n), x = K(null), $ = g("usa-character-count__field", a), p = g("usa-hint", "usa-character-count__status", {
    "usa-character-count__status--invalid": !M
  });
  Z(() => {
    const E = d(f, n);
    b(E), B(f <= n);
    const S = setTimeout(() => {
      x.current && (x.current.textContent = E);
    }, 1e3);
    return () => clearTimeout(S);
  }, [f]);
  const N = (E, S) => {
    const L = M ? "" : "The content is too long.";
    E.target.setCustomValidity(L), S && S(E);
  }, A = (E, S) => {
    const {
      target: { value: L = "" }
    } = E;
    _(v(L)), S && S(E);
  };
  let V;
  if (o) {
    const { onBlur: E, onChange: S, inputRef: L, ...y } = u, O = {
      id: e,
      name: s,
      className: $,
      ...i ? { value: i } : { defaultValue: r },
      onBlur: (D) => N(D, E),
      onChange: (D) => A(D, S),
      inputRef: L,
      ...y
    };
    V = /* @__PURE__ */ c(vr, { ...O });
  } else {
    const {
      onBlur: E,
      onChange: S,
      inputRef: L,
      type: y = "text",
      ...O
    } = u, D = {
      id: e,
      type: y,
      name: s,
      className: $,
      ...i ? { value: i } : { defaultValue: r },
      onBlur: (H) => N(H, E),
      onChange: (H) => A(H, S),
      inputRef: L,
      ...O
    };
    V = /* @__PURE__ */ c(Ve, { ...D });
  }
  return /* @__PURE__ */ z(se, { children: [
    V,
    /* @__PURE__ */ z("span", { className: "usa-sr-only", id: `${e}-info`, children: [
      "You can enter up to ",
      n,
      " characters"
    ] }),
    /* @__PURE__ */ c(
      "div",
      {
        className: p,
        "aria-hidden": "true",
        "data-testid": "characterCountMessage",
        children: k
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        ref: x,
        className: "usa-character-count__sr-status usa-sr-only",
        "aria-live": "polite",
        "data-testid": "characterCountSRMessage"
      }
    )
  ] });
}, Ol = ({
  id: e,
  name: s,
  className: a,
  label: n,
  inputRef: i,
  tile: r,
  labelDescription: o,
  ...v
}) => {
  const d = g("usa-checkbox", a), u = g("usa-checkbox__input", {
    "usa-checkbox__input--tile": r
  });
  return /* @__PURE__ */ z("div", { "data-testid": "checkbox", className: d, children: [
    /* @__PURE__ */ c(
      "input",
      {
        className: u,
        id: e,
        type: "checkbox",
        name: s,
        ref: i,
        ...v
      }
    ),
    /* @__PURE__ */ z("label", { className: "usa-checkbox__label", htmlFor: e, children: [
      n,
      o && /* @__PURE__ */ c("span", { className: "usa-checkbox__label-description", children: o })
    ] })
  ] });
}, wr = (e, s = "", a = {}) => {
  const n = (r) => r.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  let i = e.replace(/{{(.*?)}}/g, (r, o) => {
    const v = o.trim(), d = a[v];
    if (v !== "query" && d) {
      const u = new RegExp(d, "i"), w = s.match(u);
      return w ? n(w[1]) : "";
    }
    return n(s);
  });
  return i = "^(?:" + i + ")$", new RegExp(i, "i");
};
var I = /* @__PURE__ */ ((e) => (e[e.SELECT_OPTION = 0] = "SELECT_OPTION", e[e.CLEAR = 1] = "CLEAR", e[e.OPEN_LIST = 2] = "OPEN_LIST", e[e.CLOSE_LIST = 3] = "CLOSE_LIST", e[e.FOCUS_OPTION = 4] = "FOCUS_OPTION", e[e.UPDATE_FILTER = 5] = "UPDATE_FILTER", e[e.BLUR = 6] = "BLUR", e[e.CLEAR_SELECTION = 7] = "CLEAR_SELECTION", e[e.FOCUS_INPUT = 8] = "FOCUS_INPUT", e))(I || {});
const pr = (e, s, a, n) => {
  const i = (o) => {
    const v = wr(
      n.filter,
      o,
      n.extras
    ), d = s.filter(
      (u) => v.test(u.label.toLowerCase())
    );
    return a ? {
      closestMatch: d.length > 0 ? d[0] : s[0],
      optionsToDisplay: s
    } : {
      closestMatch: d[0],
      optionsToDisplay: d
    };
  };
  return Ot((o, v) => {
    switch (v.type) {
      case 0:
        return {
          ...o,
          isOpen: !1,
          selectedOption: v.option,
          focusMode: we.Input,
          inputValue: v.option.label,
          filteredOptions: s,
          focusedOption: v.option,
          statusText: ""
        };
      case 5: {
        const { closestMatch: d, optionsToDisplay: u } = i(
          v.value
        ), w = {
          ...o,
          isOpen: !0,
          filteredOptions: u,
          inputValue: v.value,
          statusText: `${u.length} result${u.length > 1 ? "s" : ""} available.`
        };
        return u.length < 1 && (w.statusText = "No results."), a || !o.selectedOption ? w.focusedOption = d : o.selectedOption && (w.filteredOptions.includes(o.selectedOption) ? w.focusedOption = o.selectedOption : w.focusedOption = d), w;
      }
      case 2: {
        const d = o.filteredOptions.length ? `${o.filteredOptions.length} result${o.filteredOptions.length > 1 ? "s" : ""} available.` : "No results.";
        return {
          ...o,
          isOpen: !0,
          focusMode: we.Input,
          focusedOption: o.selectedOption || o.focusedOption || s[0],
          statusText: d
        };
      }
      case 3: {
        const d = {
          ...o,
          isOpen: !1,
          focusMode: we.Input,
          focusedOption: void 0,
          statusText: ""
        };
        return o.filteredOptions.length === 0 && (d.filteredOptions = s, d.inputValue = ""), o.selectedOption && (d.inputValue = o.selectedOption.label), d;
      }
      case 4: {
        const d = o.filteredOptions.length ? `${o.filteredOptions.length} result${o.filteredOptions.length > 1 ? "s" : ""} available.` : "No results.";
        return {
          ...o,
          isOpen: !0,
          focusedOption: v.option,
          focusMode: we.Item,
          statusText: d
        };
      }
      case 1:
        return {
          ...o,
          inputValue: "",
          isOpen: !1,
          focusMode: we.Input,
          selectedOption: void 0,
          filteredOptions: s,
          focusedOption: s[0],
          statusText: ""
        };
      case 6: {
        const d = {
          ...o,
          isOpen: !1,
          focusMode: we.None,
          filteredOptions: s,
          statusText: ""
        };
        return o.selectedOption ? (d.inputValue = o.selectedOption.label, d.focusedOption = o.selectedOption) : (d.inputValue = "", d.focusedOption = s[0]), d;
      }
      case 7:
        return {
          ...o,
          inputValue: "",
          isOpen: !1,
          focusMode: we.None,
          selectedOption: void 0,
          filteredOptions: s,
          focusedOption: void 0,
          statusText: ""
        };
      case 8:
        return {
          ...o,
          focusMode: we.Input
        };
      default:
        throw new Error();
    }
  }, e);
}, fr = ".*{{query}}.*";
var we = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.Input = 1] = "Input", e[e.Item = 2] = "Item", e))(we || {});
const Mr = ({
  focused: e,
  ...s
}) => {
  const a = K(null);
  return Z(() => {
    e && a.current && a.current.focus();
  }), /* @__PURE__ */ c(
    "input",
    {
      type: "text",
      ...s,
      className: "usa-combo-box__input",
      "data-testid": "combo-box-input",
      autoCapitalize: "off",
      autoComplete: "off",
      ref: a
    }
  );
}, xr = ({
  id: e,
  name: s,
  className: a,
  options: n,
  defaultValue: i,
  disabled: r,
  onChange: o,
  assistiveHint: v,
  noResults: d,
  selectProps: u,
  inputProps: w,
  ulProps: f,
  customFilter: _,
  disableFiltering: k = !1
}, b) => {
  var X;
  const M = !!r;
  let B;
  i && (B = n.find((C) => C.value === i));
  const x = _ || { filter: fr }, $ = {
    isOpen: !1,
    selectedOption: B || void 0,
    focusedOption: void 0,
    focusMode: 0,
    filteredOptions: n,
    inputValue: B ? B.label : "",
    statusText: ""
  }, [p, N] = pr(
    $,
    n,
    k,
    x
  ), A = K(null), V = K(null), E = K(null);
  Z(() => {
    p.filteredOptions = n;
  }, [n]), Z(() => {
    var C;
    o && o(((C = p.selectedOption) == null ? void 0 : C.value) || void 0);
  }, [p.selectedOption]), Z(() => {
    p.focusMode === 2 && p.focusedOption && E.current && E.current.focus();
  }, [p.focusMode, p.focusedOption]), Z(() => {
    if (p.isOpen && p.focusedOption && E.current && V.current && p.focusMode === 1) {
      const C = E.current.offsetTop + E.current.offsetHeight, R = V.current.scrollTop + V.current.offsetHeight;
      C > R && (V.current.scrollTop = C - V.current.offsetHeight), E.current.offsetTop < V.current.scrollTop && (V.current.scrollTop = E.current.offsetTop);
    }
  }, [p.isOpen, p.focusedOption]), Z(() => {
    var C;
    p.focusMode !== 0 && ((C = A.current) != null && C.contains(window.document.activeElement) || N({
      type: I.BLUR
    }));
  }, [p.focusMode]), et(
    b,
    () => ({
      focus: () => N({ type: I.FOCUS_INPUT }),
      clearSelection: () => N({ type: I.CLEAR_SELECTION })
    }),
    []
  );
  const S = (C) => {
    if (C.key === "Escape")
      N({ type: I.CLOSE_LIST });
    else if (C.key === "ArrowDown" || C.key == "Down")
      C.preventDefault(), N({
        type: I.FOCUS_OPTION,
        option: p.selectedOption || p.focusedOption || p.filteredOptions[0]
      });
    else if (C.key === "Tab") {
      if (p.isOpen && !p.selectedOption) {
        const R = k ? p.focusedOption : p.selectedOption || p.focusedOption;
        R ? (C.preventDefault(), N({
          type: I.FOCUS_OPTION,
          option: R
        })) : N({
          type: I.BLUR
        });
      }
      !p.isOpen && p.selectedOption && N({
        type: I.BLUR
      });
    } else if (C.key === "Enter" && p.isOpen) {
      C.preventDefault();
      const R = p.filteredOptions.find(
        (q) => q.label.toLowerCase() === p.inputValue.toLowerCase()
      );
      R ? N({
        type: I.SELECT_OPTION,
        option: R
      }) : p.selectedOption ? N({
        type: I.CLOSE_LIST
      }) : N({ type: I.CLEAR });
    }
  }, L = (C) => {
    var Q;
    const { relatedTarget: R } = C;
    (!R || R instanceof Node && !((Q = A.current) != null && Q.contains(R))) && p.focusMode !== 0 && N({ type: I.BLUR });
  }, y = (C) => {
    C.key === "Tab" && p.isOpen && p.selectedOption && (C.preventDefault(), N({
      type: I.FOCUS_OPTION,
      option: p.selectedOption
    }));
  }, O = (C, R, q) => {
    const Q = R.focusedOption ? R.filteredOptions.indexOf(R.focusedOption) : -1, re = R.filteredOptions[0], ve = R.filteredOptions[R.filteredOptions.length - 1];
    if (Q === -1)
      C({ type: I.FOCUS_OPTION, option: re });
    else {
      const de = Q + q;
      if (de < 0)
        C({ type: I.CLOSE_LIST });
      else if (de >= R.filteredOptions.length)
        C({ type: I.FOCUS_OPTION, option: ve });
      else {
        const fe = R.filteredOptions[de];
        C({ type: I.FOCUS_OPTION, option: fe });
      }
    }
  }, D = (C) => {
    var q;
    const { relatedTarget: R } = C;
    (!R || R instanceof Node && !((q = A.current) != null && q.contains(R))) && N({ type: I.BLUR });
  }, H = (C) => {
    C.key === "Escape" ? N({ type: I.CLOSE_LIST }) : C.key === "Tab" || C.key === "Enter" ? (C.preventDefault(), p.focusedOption && N({
      type: I.SELECT_OPTION,
      option: p.focusedOption
    })) : C.key === "ArrowDown" || C.key === "Down" ? (C.preventDefault(), O(
      N,
      p,
      1
      /* Next */
    )) : (C.key === "ArrowUp" || C.key === "Up") && (C.preventDefault(), O(
      N,
      p,
      -1
      /* Previous */
    ));
  }, P = p.selectedOption && p.selectedOption.label === p.inputValue, j = g("usa-combo-box", a, {
    "usa-combo-box--pristine": P
  }), G = `${e}--list`, ee = `${e}--assistiveHint`, ie = p.focusedOption ? p.filteredOptions.findIndex((C) => C === p.focusedOption) : -1, U = ie > -1 && `${G}--option-${ie}`;
  return /* @__PURE__ */ z(
    "div",
    {
      "data-testid": "combo-box",
      "data-enhanced": "true",
      className: j,
      ref: A,
      children: [
        /* @__PURE__ */ c(
          "select",
          {
            ...u,
            className: "usa-select usa-sr-only usa-combo-box__select",
            name: s,
            "aria-hidden": !0,
            tabIndex: -1,
            defaultValue: (X = p.selectedOption) == null ? void 0 : X.value,
            "data-testid": "combo-box-select",
            children: n.map((C) => /* @__PURE__ */ c("option", { value: C.value, children: C.label }, C.value))
          }
        ),
        /* @__PURE__ */ c(
          Mr,
          {
            ...w,
            role: "combobox",
            onChange: (C) => {
              w != null && w.onChange && (w == null || w.onChange(C)), N({ type: I.UPDATE_FILTER, value: C.target.value });
            },
            onClick: () => N({ type: I.OPEN_LIST }),
            onBlur: L,
            onKeyDown: S,
            value: p.inputValue,
            focused: p.focusMode === 1,
            "aria-owns": G,
            "aria-controls": G,
            "aria-autocomplete": "list",
            "aria-describedby": ee,
            "aria-expanded": p.isOpen,
            "aria-activedescendant": p.isOpen && U || "",
            id: e,
            disabled: M
          }
        ),
        /* @__PURE__ */ c("span", { className: "usa-combo-box__clear-input__wrapper", tabIndex: -1, children: /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            className: "usa-combo-box__clear-input",
            "aria-label": "Clear the select contents",
            onClick: () => N({ type: I.CLEAR }),
            "data-testid": "combo-box-clear-button",
            onKeyDown: y,
            hidden: !P || M,
            disabled: M,
            children: " "
          }
        ) }),
        /* @__PURE__ */ c("span", { className: "usa-combo-box__input-button-separator", children: " " }),
        /* @__PURE__ */ c("span", { className: "usa-combo-box__toggle-list__wrapper", tabIndex: -1, children: /* @__PURE__ */ c(
          "button",
          {
            "data-testid": "combo-box-toggle",
            type: "button",
            className: "usa-combo-box__toggle-list",
            tabIndex: -1,
            "aria-label": "Toggle the dropdown list",
            onClick: () => N({
              type: p.isOpen ? I.CLOSE_LIST : I.OPEN_LIST
            }),
            disabled: M,
            children: " "
          }
        ) }),
        /* @__PURE__ */ z(
          "ul",
          {
            ...f,
            "data-testid": "combo-box-option-list",
            tabIndex: -1,
            id: G,
            className: "usa-combo-box__list",
            role: "listbox",
            ref: V,
            hidden: !p.isOpen,
            children: [
              p.filteredOptions.map((C, R) => {
                const q = C === p.focusedOption, Q = C === p.selectedOption, re = g("usa-combo-box__list-option", {
                  "usa-combo-box__list-option--focused": q,
                  "usa-combo-box__list-option--selected": Q
                });
                return /* @__PURE__ */ c(
                  "li",
                  {
                    ref: q ? E : null,
                    value: C.value,
                    className: re,
                    tabIndex: q ? 0 : -1,
                    role: "option",
                    "aria-selected": Q,
                    "aria-setsize": p.filteredOptions.length,
                    "aria-posinset": R + 1,
                    id: G + `--option-${R}`,
                    onKeyDown: H,
                    onBlur: D,
                    "data-testid": `combo-box-option-${C.value}`,
                    "data-value": C.value,
                    onMouseEnter: () => N({ type: I.FOCUS_OPTION, option: C }),
                    onClick: () => {
                      N({ type: I.SELECT_OPTION, option: C });
                    },
                    children: C.label
                  },
                  C.value
                );
              }),
              p.filteredOptions.length === 0 ? /* @__PURE__ */ c("li", { className: "usa-combo-box__list-option--no-results", children: d || "No results found" }) : null
            ]
          }
        ),
        /* @__PURE__ */ c("div", { className: "usa-combo-box__status usa-sr-only", role: "status", children: p.statusText }),
        /* @__PURE__ */ c(
          "span",
          {
            id: ee,
            className: "usa-sr-only",
            "data-testid": "combo-box-assistive-hint",
            children: v || `When autocomplete results are available use up and down arrows to review
           and enter to select. Touch device users, explore by touch or with swipe
           gestures.`
          }
        )
      ]
    }
  );
}, Er = _e(xr), zt = () => /* @__PURE__ */ c("abbr", { title: "required", className: "usa-hint usa-hint--required", children: "*" }), He = ({
  children: e,
  htmlFor: s,
  className: a,
  error: n,
  hint: i,
  srOnly: r,
  requiredMarker: o,
  ...v
}) => {
  const d = g(
    {
      "usa-label": !r,
      "usa-sr-only": r,
      "usa-label--error": n
    },
    a
  );
  return /* @__PURE__ */ z(
    "label",
    {
      ...v,
      "data-testid": "label",
      className: d,
      htmlFor: s,
      children: [
        e,
        i && /* @__PURE__ */ c("span", { className: "usa-hint", children: i }),
        o && /* @__PURE__ */ z(se, { children: [
          " ",
          /* @__PURE__ */ c(zt, {})
        ] })
      ]
    }
  );
}, Pe = ({
  children: e,
  className: s,
  error: a
}) => {
  const n = g(
    "usa-form-group",
    { "usa-form-group--error": a },
    s
  );
  return /* @__PURE__ */ c("div", { "data-testid": "formGroup", className: n, children: e });
}, Al = ({
  id: e,
  name: s,
  label: a,
  unit: n,
  maxLength: i,
  minLength: r,
  className: o,
  ...v
}) => {
  const d = g({
    "usa-form-group--month": n == "month",
    "usa-form-group--day": n == "day",
    "usa-form-group--year": n == "year"
  }), u = g(o);
  return /* @__PURE__ */ z(Pe, { className: d, children: [
    /* @__PURE__ */ c(He, { htmlFor: e, children: a }),
    /* @__PURE__ */ c(
      Ve,
      {
        ...v,
        className: u,
        id: e,
        name: s,
        type: "text",
        maxLength: i,
        minLength: r,
        pattern: "[0-9]*",
        inputMode: "numeric"
      }
    )
  ] });
}, Dl = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-memorable-date", s);
  return /* @__PURE__ */ c("div", { className: n, ...a, "data-testid": "dateInputGroup", children: e });
}, vt = "Please enter a valid date", br = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], zr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], Sr = ["S", "M", "T", "W", "Th", "F", "S"], ge = 12, _r = "0000-01-01", ye = "MM/DD/YYYY", St = "YYYY-MM-DD", We = {
  months: br,
  daysOfWeek: zr,
  daysOfWeekShort: Sr,
  statuses: [
    "You can navigate by day using left and right arrows",
    "Weeks by using up and down arrows",
    "Months by using page up and page down keys",
    "Years by using shift plus page up and shift plus page down",
    "Home and end keys navigate to the beginning and end of a week"
  ],
  selectedDate: "Selected date",
  selectAMonth: "Select a month.",
  toggleCalendar: "Toggle calendar",
  backOneYear: "Navigate back one year",
  backOneMonth: "Navigate back one month",
  forwardOneYear: "Navigate forward one year",
  forwardOneMonth: "Navigate forward one month",
  selectMonth: "Select month",
  selectYear: "Select year"
}, st = (e, s) => (s !== e.getMonth() && e.setDate(0), e), Re = (e, s, a) => {
  const n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e, s, a), n;
}, Ue = () => {
  const e = /* @__PURE__ */ new Date(), s = e.getDate(), a = e.getMonth(), n = e.getFullYear();
  return Re(n, a, s);
}, at = (e) => {
  const s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(e.getFullYear(), e.getMonth(), 1), s;
}, _t = (e) => {
  const s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(e.getFullYear(), e.getMonth() + 1, 0), s;
}, Ee = (e, s) => {
  const a = new Date(e.getTime());
  return a.setDate(a.getDate() + s), a;
}, Qe = (e, s) => Ee(e, -s), Ct = (e, s) => Ee(e, s * 7), Cr = (e, s) => Ct(e, -s), gt = (e) => {
  const s = e.getDay();
  return Qe(e, s);
}, Nr = (e) => {
  const s = e.getDay();
  return Ee(e, 6 - s);
}, $e = (e, s) => {
  const a = new Date(e.getTime()), n = (a.getMonth() + 12 + s) % 12;
  return a.setMonth(a.getMonth() + s), st(a, n), a;
}, Ze = (e, s) => $e(e, -s), Je = (e, s) => $e(e, s * 12), ut = (e, s) => Je(e, -s), Le = (e, s) => {
  const a = new Date(e.getTime());
  return a.setMonth(s), st(a, s), a;
}, xe = (e, s) => {
  const a = new Date(e.getTime()), n = a.getMonth();
  return a.setFullYear(s), st(a, n), a;
}, yr = (e, s) => {
  let a = e;
  return s < e && (a = s), new Date(a.getTime());
}, Lr = (e, s) => {
  let a = e;
  return s > e && (a = s), new Date(a.getTime());
}, Nt = (e, s) => e && s && e.getFullYear() === s.getFullYear(), be = (e, s) => Nt(e, s) && e.getMonth() === s.getMonth(), pe = (e, s) => be(e, s) && e.getDate() === s.getDate(), he = (e, s, a) => {
  let n = e;
  return e < s ? n = s : a && e > a && (n = a), new Date(n.getTime());
}, Xe = (e, s, a) => e >= s && (!a || e <= a), kr = (e, s, a) => _t(e) < s || !!a && at(e) > a, Ge = (e, s, a) => _t(Le(e, 11)) < s || !!a && at(Le(e, 0)) > a, oe = (e, s = St, a = !1) => {
  let n, i, r, o, v;
  if (e) {
    let d, u, w;
    if (s === ye ? [d, u, w] = e.split("/") : [w, d, u] = e.split("-"), w && (v = parseInt(w, 10), !Number.isNaN(v) && (o = v, a && (o = Math.max(0, o), w.length < 3)))) {
      const f = Ue().getFullYear();
      o = f - f % 10 ** w.length + v;
    }
    if (d && (v = parseInt(d, 10), Number.isNaN(v) || (i = v, a && (i = Math.max(1, i), i = Math.min(12, i)))), i && u && o != null && (v = parseInt(u, 10), !Number.isNaN(v) && (r = v, a))) {
      const f = Re(o, i, 0).getDate();
      r = Math.max(1, r), r = Math.min(f, r);
    }
    i && r && o != null && (n = Re(o, i - 1, r));
  }
  return n;
}, le = (e, s = St) => {
  const a = (o, v) => `0000${o}`.slice(-v), n = e.getMonth() + 1, i = e.getDate(), r = e.getFullYear();
  return s === ye ? [a(n, 2), a(i, 2), a(r, 4)].join("/") : [a(r, 4), a(n, 2), a(i, 2)].join("-");
}, wt = (e, s, a) => {
  let n = !1;
  if (e) {
    n = !0;
    const i = e.split("/"), [r, o, v] = i.map((d) => {
      let u;
      const w = parseInt(d, 10);
      return Number.isNaN(w) || (u = w), u;
    });
    if (r && o && v != null) {
      const d = Re(v, r - 1, o);
      d.getMonth() === r - 1 && d.getDate() === o && d.getFullYear() === v && i[2].length === 4 && Xe(d, s, a) && (n = !1);
    }
  }
  return n;
}, nt = (e, s) => {
  const a = [];
  let n = 0;
  for (; n < e.length; ) {
    const i = [];
    for (; n < e.length && i.length < s; )
      i.push(e[parseInt(`${n}`)]), n += 1;
    a.push(i);
  }
  return /* @__PURE__ */ c(se, { children: a.map((i, r) => /* @__PURE__ */ c("tr", { children: i.map((o, v) => /* @__PURE__ */ c("td", { children: o }, `row_${r}_cell_${v}`)) }, `row_${r}`)) });
}, ct = (e, s) => {
  if (e.key === "Tab") {
    const a = s.filter((_) => _ && !_.disabled), n = document == null ? void 0 : document.activeElement, i = 0, r = a.length - 1, o = a[parseInt(`${i}`)], v = a[parseInt(`${r}`)], d = n instanceof HTMLButtonElement ? a.indexOf(n) : -1, u = d === r, w = d === i, f = d === -1;
    e.shiftKey ? (w || f) && (e.preventDefault(), v == null || v.focus()) : (u || f) && (e.preventDefault(), o == null || o.focus());
  }
}, it = () => typeof navigator < "u" && (navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && !window.MSStream, $r = ({
  date: e,
  onClick: s,
  onKeyDown: a,
  onMouseMove: n,
  isDisabled: i = !1,
  isSelected: r = !1,
  isFocused: o = !1,
  isPrevMonth: v = !1,
  isFocusedMonth: d = !1,
  isNextMonth: u = !1,
  isToday: w = !1,
  isRangeDate: f = !1,
  isRangeStart: _ = !1,
  isRangeEnd: k = !1,
  isWithinRange: b = !1,
  i18n: M = We
}, B) => {
  const x = e.getDate(), $ = e.getMonth(), p = e.getFullYear(), N = e.getDay(), A = le(e), V = o ? 0 : -1, E = g("usa-date-picker__calendar__date", {
    "usa-date-picker__calendar__date--previous-month": v,
    "usa-date-picker__calendar__date--current-month": d,
    "usa-date-picker__calendar__date--next-month": u,
    "usa-date-picker__calendar__date--selected": r,
    "usa-date-picker__calendar__date--today": w,
    "usa-date-picker__calendar__date--focused": o,
    "usa-date-picker__calendar__date--range-date": f,
    "usa-date-picker__calendar__date--range-date-start": _,
    "usa-date-picker__calendar__date--range-date-end": k,
    "usa-date-picker__calendar__date--within-range": b
  }), S = M.months[parseInt(`${$}`)], L = M.daysOfWeek[parseInt(`${N}`)], y = () => {
    s(A);
  }, O = (H) => {
    a(H);
  }, D = () => {
    i || it() || n(e);
  };
  return (
    // Ignoring error: "The attribute aria-selected is not supported by the role button. This role is implicit on the element button."
    // Ignoring because this attribute is present in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1017)
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        "data-testid": "select-date",
        ref: B,
        onClick: y,
        tabIndex: V,
        className: E,
        "data-day": x,
        "data-month": $ + 1,
        "data-year": p,
        "data-value": A,
        "aria-label": `${x} ${S} ${p} ${L}`,
        "aria-selected": !!r,
        disabled: i,
        onKeyDown: O,
        onMouseMove: d ? D : void 0,
        children: x
      }
    )
  );
}, Hr = _e($r), Vr = ({
  date: e,
  minDate: s,
  maxDate: a,
  handleSelectMonth: n,
  i18n: i = We
}) => {
  const r = e.getMonth(), [o, v] = F(r), d = K(null), u = K(null);
  Z(() => {
    const b = d.current && d.current.querySelector(
      `[data-value="${o}"]`
    );
    b && b.focus();
  }, [o]);
  const w = (b) => {
    ct(b, [u == null ? void 0 : u.current]);
  }, f = (b) => {
    var p;
    let M;
    const B = b.target, x = parseInt(((p = B.dataset) == null ? void 0 : p.value) || "", 10), $ = Le(e, x);
    switch (b.key) {
      case "ArrowUp":
      case "Up":
        M = x - 3;
        break;
      case "ArrowDown":
      case "Down":
        M = x + 3;
        break;
      case "ArrowLeft":
      case "Left":
        M = x - 1;
        break;
      case "ArrowRight":
      case "Right":
        M = x + 1;
        break;
      case "Home":
        M = x - x % 3;
        break;
      case "End":
        M = x + 2 - x % 3;
        break;
      case "PageDown":
        M = 11;
        break;
      case "PageUp":
        M = 0;
        break;
      default:
        return;
    }
    if (M !== void 0) {
      M = Math.max(0, Math.min(11, M));
      const N = Le(e, M), A = he(N, s, a);
      be($, A) || v(A.getMonth());
    }
    b.preventDefault();
  }, k = i.months.map((b, M) => {
    const B = Le(e, M), x = kr(
      B,
      s,
      a
    ), $ = M === r, p = M === o, N = p ? 0 : -1, A = g("usa-date-picker__calendar__month", {
      "usa-date-picker__calendar__month--selected": $,
      "usa-date-picker__calendar__month--focused": p
    });
    return (
      // Ignoring error: "The attribute aria-selected is not supported by the role button. This role is implicit on the element button."
      // Ignoring because this attribute is present in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1340)
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          ref: p ? u : null,
          tabIndex: N,
          className: A,
          "data-value": M,
          "data-label": b,
          "aria-selected": $,
          disabled: x,
          onClick: () => {
            n(M);
          },
          onKeyDown: f,
          onMouseMove: () => {
            x || it() || M !== o && v(M);
          },
          children: b
        },
        `selectMonth_${b}`
      )
    );
  });
  return (
    // Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1345)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ c(
      "div",
      {
        tabIndex: -1,
        "data-testid": "calendar-month-picker",
        className: "usa-date-picker__calendar__month-picker",
        ref: d,
        onKeyDown: w,
        children: /* @__PURE__ */ c("table", { className: "usa-date-picker__calendar__table", role: "presentation", children: /* @__PURE__ */ c("tbody", { children: nt(k, 3) }) })
      }
    )
  );
}, Br = ({
  date: e,
  minDate: s,
  maxDate: a,
  handleSelectYear: n,
  setStatuses: i
}) => {
  const r = K(null), o = K(null), v = K(null), d = K(null), u = e.getFullYear(), [w, f] = F(u), [_, k] = F([null, null]);
  let b = w;
  b -= b % ge, b = Math.max(0, b);
  const M = Ge(
    xe(e, b - 1),
    s,
    a
  ), B = Ge(
    xe(e, b + ge),
    s,
    a
  );
  Z(() => {
    const E = `Showing years ${b} to ${b + ge - 1}. Select a year.`;
    i([E]);
    const [S, L] = _;
    if (S && L)
      S.disabled ? L.focus() : S.focus(), k([null, null]);
    else {
      const y = d.current && d.current.querySelector(
        ".usa-date-picker__calendar__year--focused"
      );
      y && y.focus();
    }
  }, [w]), Z(() => {
    const E = d.current && d.current.querySelector(
      `[data-value="${w}"]`
    );
    E && E.focus();
  }, []);
  const x = (E) => {
    ct(E, [
      r == null ? void 0 : r.current,
      v == null ? void 0 : v.current,
      o == null ? void 0 : o.current
    ]);
  }, $ = (E) => {
    var D;
    let S;
    const L = E.target, y = parseInt(((D = L.dataset) == null ? void 0 : D.value) || "", 10), O = xe(e, y);
    switch (E.key) {
      case "ArrowUp":
      case "Up":
        S = y - 3;
        break;
      case "ArrowDown":
      case "Down":
        S = y + 3;
        break;
      case "ArrowLeft":
      case "Left":
        S = y - 1;
        break;
      case "ArrowRight":
      case "Right":
        S = y + 1;
        break;
      case "Home":
        S = y - y % 3;
        break;
      case "End":
        S = y + 2 - y % 3;
        break;
      case "PageDown":
        S = y + ge;
        break;
      case "PageUp":
        S = y - ge;
        break;
      default:
        return;
    }
    if (S !== void 0) {
      S = Math.max(0, S);
      const H = xe(e, S), P = he(H, s, a);
      Nt(O, P) || f(P.getFullYear());
    }
    E.preventDefault();
  }, p = [];
  let N = b;
  for (; p.length < ge; ) {
    const E = N, S = Ge(
      xe(e, E),
      s,
      a
    ), L = E === u, y = E === w, O = y ? 0 : -1, D = g("usa-date-picker__calendar__year", {
      "usa-date-picker__calendar__year--selected": L,
      "usa-date-picker__calendar__year--focused": y
    }), H = () => {
      n(E);
    }, P = () => {
      S || it() || E !== w && f(E);
    };
    p.push(
      // Ignoring error: "The attribute aria-selected is not supported by the role button. This role is implicit on the element button."
      // Ignoring because this attribute is present in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1447)
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          tabIndex: O,
          ref: y ? v : null,
          className: D,
          "data-value": E,
          "aria-selected": L,
          disabled: S,
          onClick: H,
          onKeyDown: $,
          onMouseMove: P,
          children: E
        }
      )
    ), N += 1;
  }
  const A = () => {
    let E = w - ge;
    E = Math.max(0, E);
    let S = xe(e, E);
    S = he(S, s, a), k([r.current, d.current]), f(S.getFullYear());
  }, V = () => {
    let E = w + ge;
    E = Math.max(0, E);
    let S = xe(e, E);
    S = he(S, s, a), k([o.current, d.current]), f(S.getFullYear());
  };
  return (
    // Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1457)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ c(
      "div",
      {
        tabIndex: -1,
        className: "usa-date-picker__calendar__year-picker",
        "data-testid": "calendar-year-picker",
        ref: d,
        onKeyDown: x,
        children: /* @__PURE__ */ c("table", { className: "usa-date-picker__calendar__table", role: "presentation", children: /* @__PURE__ */ c("tbody", { children: /* @__PURE__ */ z("tr", { children: [
          /* @__PURE__ */ c("td", { children: /* @__PURE__ */ c(
            "button",
            {
              type: "button",
              "data-testid": "previous-year-chunk",
              className: "usa-date-picker__calendar__previous-year-chunk",
              "aria-label": `Navigate back ${ge} years`,
              disabled: M,
              onClick: A,
              ref: r
            }
          ) }),
          /* @__PURE__ */ c("td", { colSpan: 3, children: /* @__PURE__ */ c(
            "table",
            {
              className: "usa-date-picker__calendar__table",
              role: "presentation",
              children: /* @__PURE__ */ c("tbody", { children: nt(p, 3) })
            }
          ) }),
          /* @__PURE__ */ c("td", { children: /* @__PURE__ */ c(
            "button",
            {
              type: "button",
              "data-testid": "next-year-chunk",
              className: "usa-date-picker__calendar__next-year-chunk",
              "aria-label": `Navigate forward ${ge} years`,
              disabled: B,
              onClick: V,
              ref: o
            }
          ) })
        ] }) }) })
      }
    )
  );
}, Me = {
  DATE_PICKER: "DATE_PICKER",
  MONTH_PICKER: "MONTH_PICKER",
  YEAR_PICKER: "YEAR_PICKER"
}, Or = ({
  date: e,
  selectedDate: s,
  handleSelectDate: a,
  minDate: n,
  maxDate: i,
  rangeDate: r,
  setStatuses: o,
  focusMode: v,
  i18n: d = We
}) => {
  const u = K(null), w = K(null), f = K(null), _ = K(null), k = K(null), b = K(null), M = K(null), B = K(null), [x, $] = F(e || Ue()), [p, N] = F(Me.DATE_PICKER), [A, V] = F([null, null]);
  let E = !0;
  const S = (T) => {
    let W = Le(x, T);
    W = he(W, n, i), $(W), N(Me.DATE_PICKER);
  }, L = (T) => {
    let W = xe(x, T);
    W = he(W, n, i), $(W), N(Me.DATE_PICKER);
  }, y = Ee(x, 0), O = x.getMonth(), D = x.getFullYear(), H = d.months[parseInt(`${O}`)], P = d.daysOfWeekShort, j = d.daysOfWeek, G = d.backOneYear, ee = d.backOneMonth, ie = `${H}. ${d.selectMonth}`, U = `${D}. ${d.selectYear}`, X = d.forwardOneMonth, C = d.forwardOneYear;
  if (Z(() => {
    E = !1;
  }, []), Z(() => {
    e && p === Me.DATE_PICKER && $(e);
  }, [e]), Z(() => {
    if (v !== yt.Input) {
      const [T, W] = A;
      if (T && W)
        T.disabled ? W.focus() : T.focus(), V([null, null]);
      else {
        const De = B.current && B.current.querySelector(
          ".usa-date-picker__calendar__date--focused"
        );
        De && De.focus();
      }
    }
    if (E) {
      const T = [`${H} ${D}`];
      if (s && pe(y, s)) {
        const W = d.selectedDate;
        T.unshift(W);
      }
      o(T);
    }
  }, [x]), p === Me.MONTH_PICKER)
    return /* @__PURE__ */ c(
      Vr,
      {
        date: x,
        minDate: n,
        maxDate: i,
        handleSelectMonth: S,
        i18n: d
      }
    );
  if (p === Me.YEAR_PICKER)
    return /* @__PURE__ */ c(
      Br,
      {
        date: x,
        minDate: n,
        maxDate: i,
        handleSelectYear: L,
        setStatuses: o
      }
    );
  const R = Ze(x, 1), q = $e(x, 1), Q = at(x), re = be(x, n), ve = i && be(x, i), de = s || x, fe = r && yr(de, r), Ce = r && Lr(de, r), Be = fe && Ee(fe, 1), Oe = Ce && Qe(Ce, 1), Y = (T) => {
    ct(T, [
      u == null ? void 0 : u.current,
      w == null ? void 0 : w.current,
      k == null ? void 0 : k.current,
      b == null ? void 0 : b.current,
      f == null ? void 0 : f.current,
      _ == null ? void 0 : _.current,
      M == null ? void 0 : M.current
    ]);
  }, J = (T) => {
    let W;
    switch (T.key) {
      case "ArrowUp":
      case "Up":
        W = Cr(x, 1);
        break;
      case "ArrowDown":
      case "Down":
        W = Ct(x, 1);
        break;
      case "ArrowLeft":
      case "Left":
        W = Qe(x, 1);
        break;
      case "ArrowRight":
      case "Right":
        W = Ee(x, 1);
        break;
      case "Home":
        W = gt(x);
        break;
      case "End":
        W = Nr(x);
        break;
      case "PageDown":
        T.shiftKey ? W = Je(x, 1) : W = $e(x, 1);
        break;
      case "PageUp":
        T.shiftKey ? W = ut(x, 1) : W = Ze(x, 1);
        break;
      default:
        return;
    }
    if (W !== void 0) {
      const De = he(
        W,
        n,
        i
      );
      pe(x, De) || $(W);
    }
    T.preventDefault();
  }, te = (T) => {
    T !== x && $(T);
  }, ne = () => {
    let T = ut(x, 1);
    T = he(T, n, i), $(T), V([u.current, B.current]);
  }, me = () => {
    let T = Ze(x, 1);
    T = he(T, n, i), $(T), V([w.current, B.current]);
  }, Ke = () => {
    let T = $e(x, 1);
    T = he(T, n, i), $(T), V([f.current, B.current]);
  }, $t = () => {
    let T = Je(x, 1);
    T = he(T, n, i), $(T), V([_.current, B.current]);
  }, Ht = () => {
    N(Me.MONTH_PICKER);
    const T = d.selectAMonth;
    o([T]);
  }, Vt = () => {
    N(Me.YEAR_PICKER);
  }, Ae = [];
  let ce = gt(Q);
  for (; Ae.length < 28 || ce.getMonth() === O || Ae.length % 7 !== 0; ) {
    const T = pe(ce, y);
    Ae.push(
      /* @__PURE__ */ c(
        Hr,
        {
          date: ce,
          onClick: a,
          onKeyDown: J,
          onMouseMove: te,
          ref: T ? M : null,
          isDisabled: !Xe(ce, n, i),
          isSelected: s && pe(ce, s),
          isFocused: T,
          isPrevMonth: be(ce, R),
          isFocusedMonth: be(ce, y),
          isNextMonth: be(ce, q),
          isToday: pe(ce, Ue()),
          isRangeDate: r && pe(ce, r),
          isRangeStart: fe && pe(ce, fe),
          isRangeEnd: Ce && pe(ce, Ce),
          isWithinRange: Be && Oe && Xe(
            ce,
            Be,
            Oe
          ),
          i18n: d
        }
      )
    ), ce = Ee(ce, 1);
  }
  return (
    // Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1042)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ z(
      "div",
      {
        tabIndex: -1,
        className: "usa-date-picker__calendar__date-picker",
        "data-testid": "calendar-date-picker",
        ref: B,
        onKeyDown: Y,
        children: [
          /* @__PURE__ */ z("div", { className: "usa-date-picker__calendar__row", children: [
            /* @__PURE__ */ c("div", { className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items", children: /* @__PURE__ */ c(
              "button",
              {
                type: "button",
                "data-testid": "previous-year",
                onClick: ne,
                ref: u,
                className: "usa-date-picker__calendar__previous-year",
                "aria-label": G,
                disabled: re
              }
            ) }),
            /* @__PURE__ */ c("div", { className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items", children: /* @__PURE__ */ c(
              "button",
              {
                type: "button",
                "data-testid": "previous-month",
                onClick: me,
                ref: w,
                className: "usa-date-picker__calendar__previous-month",
                "aria-label": ee,
                disabled: re
              }
            ) }),
            /* @__PURE__ */ z("div", { className: "usa-date-picker__calendar__cell usa-date-picker__calendar__month-label", children: [
              /* @__PURE__ */ c(
                "button",
                {
                  type: "button",
                  "data-testid": "select-month",
                  onClick: Ht,
                  ref: k,
                  className: "usa-date-picker__calendar__month-selection",
                  "aria-label": ie,
                  children: H
                }
              ),
              /* @__PURE__ */ c(
                "button",
                {
                  type: "button",
                  "data-testid": "select-year",
                  onClick: Vt,
                  ref: b,
                  className: "usa-date-picker__calendar__year-selection",
                  "aria-label": U,
                  children: D
                }
              )
            ] }),
            /* @__PURE__ */ c("div", { className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items", children: /* @__PURE__ */ c(
              "button",
              {
                type: "button",
                "data-testid": "next-month",
                onClick: Ke,
                ref: f,
                className: "usa-date-picker__calendar__next-month",
                "aria-label": X,
                disabled: ve
              }
            ) }),
            /* @__PURE__ */ c("div", { className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items", children: /* @__PURE__ */ c(
              "button",
              {
                type: "button",
                "data-testid": "next-year",
                onClick: $t,
                ref: _,
                className: "usa-date-picker__calendar__next-year",
                "aria-label": C,
                disabled: ve
              }
            ) })
          ] }),
          /* @__PURE__ */ z("table", { className: "usa-date-picker__calendar__table", children: [
            /* @__PURE__ */ c("thead", { children: /* @__PURE__ */ c("tr", { children: P.map((T, W) => /* @__PURE__ */ c(
              "th",
              {
                className: "usa-date-picker__calendar__day-of-week",
                scope: "col",
                "aria-label": j[parseInt(`${W}`)],
                children: T
              },
              `day-of-week-${T}-${W}`
            )) }) }),
            /* @__PURE__ */ c("tbody", { children: nt(Ae, 7) })
          ] })
        ]
      }
    )
  );
};
var yt = /* @__PURE__ */ ((e) => (e[e.None = 0] = "None", e[e.Input = 1] = "Input", e))(yt || {});
const pt = ({
  id: e,
  name: s,
  className: a,
  validationStatus: n,
  defaultValue: i,
  disabled: r,
  required: o,
  minDate: v = _r,
  maxDate: d,
  rangeDate: u,
  onChange: w,
  onBlur: f,
  i18n: _ = We,
  ...k
}) => {
  const b = K(null), M = K(null), B = n === "error", x = n === "success", [$, p] = F(""), [N, A] = F(""), [V, E] = F(!1), [S, L] = F(void 0), [y, O] = F(0), [D, H] = F([]), [P, j] = F(
    0
    /* None */
  ), [G, ee] = F(
    void 0
  ), ie = oe(v), U = d ? oe(d) : void 0, X = u ? oe(u) : void 0, C = () => {
    var J, te, ne, me;
    const Y = wt(N, ie, U);
    Y && !((J = M == null ? void 0 : M.current) != null && J.validationMessage) && ((te = M == null ? void 0 : M.current) == null || te.setCustomValidity(vt)), !Y && ((ne = M == null ? void 0 : M.current) == null ? void 0 : ne.validationMessage) === vt && ((me = M == null ? void 0 : M.current) == null || me.setCustomValidity(""));
  }, R = (Y, J = !0) => {
    var me;
    const te = oe(Y), ne = te && le(te, ye);
    te && p(Y), ne && A(ne), w && w(ne), J && (E(!1), H([]), (me = M == null ? void 0 : M.current) == null || me.focus());
  }, q = (Y) => {
    const J = Y.target.value;
    A(J), w && w(J);
    const te = oe(J, ye, !0);
    let ne = "";
    if (te && !wt(J, ie, U) && (ne = le(te)), $ !== ne && p(ne), te && V) {
      const me = he(
        te,
        ie,
        U
      );
      L(me);
    }
  };
  Z(() => {
    i && R(i, !1);
  }, []), Z(() => {
    if (V) {
      const Y = b.current && b.current.querySelector(
        ".usa-date-picker__calendar__date--focused"
      );
      Y && Y.focus();
    }
  }, [V]), Z(() => {
    C();
  }, [N, v, d]);
  const Q = () => {
    var Y;
    if (V)
      H([]);
    else {
      const J = oe(
        N,
        ye,
        !0
      ), te = he(
        J || i && oe(i) || Ue(),
        ie,
        U
      );
      L(te), O((Y = b == null ? void 0 : b.current) == null ? void 0 : Y.offsetHeight);
      const ne = _.statuses, me = oe($);
      if (me && pe(me, Ee(te, 0))) {
        const Ke = _.selectedDate;
        ne.unshift(Ke);
      }
      H(ne);
    }
    E(!V);
  }, re = (Y) => {
    var J;
    (J = b.current) != null && J.contains(Y == null ? void 0 : Y.relatedTarget) || (V && (E(!1), H([])), f && f(Y));
  }, ve = (Y) => {
    var J;
    Y.key === "Escape" && (V && (E(!1), H([]), (J = M == null ? void 0 : M.current) == null || J.focus()), Y.preventDefault());
  }, de = (Y) => {
    ee(Y.keyCode);
  }, fe = (Y) => {
    Y.keyCode !== G && Y.preventDefault();
  }, Ce = g(
    "usa-date-picker",
    "usa-date-picker--initialized",
    {
      "usa-date-picker--active": V
    },
    a
  ), Be = g(
    "usa-input",
    "usa-date-picker__external-input",
    {
      "usa-input--error": B,
      "usa-input--success": x
    }
  ), Oe = _.toggleCalendar;
  return (
    // Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L828)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ z(
      "div",
      {
        "data-testid": "date-picker",
        className: Ce,
        ref: b,
        onBlur: re,
        onKeyDown: ve,
        children: [
          /* @__PURE__ */ c(
            "input",
            {
              ...k,
              name: s,
              "data-testid": "date-picker-internal-input",
              className: "usa-input usa-sr-only usa-date-picker__internal-input",
              type: "text",
              "aria-hidden": !0,
              tabIndex: -1,
              required: !1,
              disabled: !1,
              value: $,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ z("div", { className: "usa-date-picker__wrapper", tabIndex: -1, children: [
            /* @__PURE__ */ c(
              "input",
              {
                ...k,
                id: e,
                "data-testid": "date-picker-external-input",
                className: Be,
                type: "text",
                disabled: r,
                required: o,
                value: N,
                ref: M,
                onInput: q,
                onFocus: () => {
                  j(
                    1
                    /* Input */
                  );
                },
                onBlur: (Y) => {
                  j(
                    0
                    /* None */
                  ), f && f(Y);
                }
              }
            ),
            /* @__PURE__ */ c(
              "button",
              {
                "data-testid": "date-picker-button",
                type: "button",
                className: "usa-date-picker__button",
                "aria-haspopup": !0,
                "aria-label": Oe,
                disabled: r,
                onClick: Q
              }
            ),
            /* @__PURE__ */ c(
              "div",
              {
                "data-testid": "date-picker-calendar",
                className: "usa-date-picker__calendar",
                role: "application",
                hidden: !V,
                "data-value": S && le(S),
                style: { top: `${y}px` },
                onKeyDown: de,
                onKeyUp: fe,
                children: V && /* @__PURE__ */ c(
                  Or,
                  {
                    date: S,
                    handleSelectDate: R,
                    minDate: ie,
                    maxDate: U,
                    rangeDate: X,
                    selectedDate: oe($),
                    setStatuses: H,
                    focusMode: P,
                    i18n: _
                  }
                )
              }
            ),
            /* @__PURE__ */ c(
              "div",
              {
                "data-testid": "date-picker-status",
                className: "usa-sr-only usa-date-picker__status",
                role: "status",
                "aria-live": "polite",
                children: D.join(". ")
              }
            )
          ] })
        ]
      }
    )
  );
}, Tl = (e) => {
  const {
    startDateLabel: s,
    startDateHint: a,
    startDatePickerProps: n,
    endDateLabel: i,
    endDateHint: r,
    endDatePickerProps: o,
    className: v
  } = e, [d, u] = F(n.defaultValue), [w, f] = F(o.defaultValue), _ = () => {
    const { maxDate: S } = n, L = S && oe(S), y = w && oe(w);
    return y && L ? y.getTime() < L.getTime() ? le(y) : le(L) : y && le(y) || L && le(L) || void 0;
  }, k = () => {
    const { minDate: S } = o, L = S && oe(S), y = d && oe(d);
    return y && L ? y.getTime() > L.getTime() ? le(y) : le(L) : y && le(y) || L && le(L) || void 0;
  }, b = (S, L) => (y) => {
    const O = y && oe(y, ye);
    if (O) {
      const D = le(O);
      L(D);
    } else
      L(y);
    S && S(y);
  }, M = b(
    n.onChange,
    u
  ), B = b(
    o.onChange,
    f
  ), x = g(v, "usa-date-range-picker"), $ = g(
    n.className,
    "usa-date-range-picker__range-start"
  ), p = g(
    o.className,
    "usa-date-range-picker__range-end"
  ), N = `${n.id}-label`, A = `${n.id}-hint`, V = `${o.id}-label`, E = `${o.id}-hint`;
  return /* @__PURE__ */ z("div", { className: x, "data-testid": "date-range-picker", children: [
    /* @__PURE__ */ z(Pe, { children: [
      s && /* @__PURE__ */ c(He, { id: N, htmlFor: n.id, children: s }),
      a && /* @__PURE__ */ c("div", { className: "usa-hint", id: A, children: a }),
      /* @__PURE__ */ c(
        pt,
        {
          className: $,
          rangeDate: w,
          ...n,
          "aria-labelledby": s && N,
          "aria-describedby": a && A,
          onChange: M,
          maxDate: _()
        }
      )
    ] }),
    /* @__PURE__ */ z(Pe, { children: [
      i && /* @__PURE__ */ c(He, { id: V, htmlFor: o.id, children: i }),
      r && /* @__PURE__ */ c("div", { className: "usa-hint", id: E, children: r }),
      /* @__PURE__ */ c(
        pt,
        {
          className: p,
          rangeDate: d,
          ...o,
          "aria-labelledby": i && V,
          "aria-describedby": r && E,
          onChange: B,
          minDate: k()
        }
      )
    ] })
  ] });
}, Fl = ({
  children: e,
  className: s,
  id: a
}) => {
  const n = g("usa-error-message", s);
  return /* @__PURE__ */ c("span", { "data-testid": "errorMessage", className: n, id: a, role: "alert", children: e });
}, Pl = ({
  children: e,
  legend: s,
  className: a,
  legendStyle: n = "default",
  requiredMarker: i,
  ...r
}) => {
  const o = g("usa-fieldset", a), v = g({
    "usa-legend": n === "default",
    "usa-legend--large": n === "large",
    "usa-sr-only": n === "srOnly"
  });
  return /* @__PURE__ */ z("fieldset", { "data-testid": "fieldset", className: o, ...r, children: [
    s && /* @__PURE__ */ z("legend", { className: v, children: [
      s,
      i && /* @__PURE__ */ z(se, { children: [
        " ",
        /* @__PURE__ */ c(zt, {})
      ] })
    ] }),
    e
  ] });
}, ft = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", Ar = ({
  imageId: e,
  file: s
}) => {
  const a = K(new FileReader()), [n, i] = F(!0), [r, o] = F(ft), [v, d] = F(!1);
  Z(() => (a.current.onloadend = () => {
    i(!1), o(a.current.result);
  }, a.current.readAsDataURL(s), () => {
    a.current.onloadend = null;
  }), []);
  const { name: u } = s, w = () => {
    o(ft), d(!0);
  }, f = u.indexOf(".pdf") > 0, _ = u.indexOf(".doc") > 0 || u.indexOf(".pages") > 0, k = u.indexOf(".mov") > 0 || u.indexOf(".mp4") > 0, b = u.indexOf(".xls") > 0 || u.indexOf(".numbers") > 0, B = g("usa-file-input__preview-image", {
    "is-loading": n,
    "usa-file-input__preview-image--pdf": v && f,
    "usa-file-input__preview-image--word": v && _,
    "usa-file-input__preview-image--video": v && k,
    "usa-file-input__preview-image--excel": v && b,
    "usa-file-input__preview-image--generic": v && (!f && !_ && !k && !b)
  });
  return /* @__PURE__ */ z(
    "div",
    {
      "data-testid": "file-input-preview",
      className: "usa-file-input__preview",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ c(
          "img",
          {
            id: e,
            "data-testid": "file-input-preview-image",
            src: r,
            alt: "",
            className: B,
            onError: w
          }
        ),
        u
      ]
    }
  );
}, Dr = (e) => e.replace(/[^a-z0-9]/g, function(a) {
  const n = a.charCodeAt(0);
  return n === 32 ? "-" : n >= 65 && n <= 90 ? `img_${a.toLowerCase()}` : `__${n.toString(16).slice(-4)}`;
}), Tr = ({
  name: e,
  id: s,
  dragText: a,
  chooseText: n,
  errorText: i,
  disabled: r,
  multiple: o,
  className: v,
  accept: d,
  onChange: u,
  onDrop: w,
  ...f
}, _) => {
  const k = K(null), [b, M] = F(!1), [B, x] = F(!1), [$, p] = F([]), [N, A] = F(!1);
  Z(() => {
    if (typeof navigator > "u") return;
    const U = /rv:11.0/i.test(navigator == null ? void 0 : navigator.userAgent) || /Edge\/\d./i.test(navigator == null ? void 0 : navigator.userAgent);
    A(U);
  }, [typeof navigator]), et(
    _,
    () => ({
      input: k.current,
      clearFiles: () => p([]),
      files: $
    }),
    [$]
  );
  const V = g(
    "usa-file-input",
    {
      "usa-file-input--disabled": r
    },
    v
  ), E = g("usa-file-input__target", {
    "usa-file-input--drag": b,
    "has-invalid-file": B
  }), S = o ? "Drag files here or " : "Drag file here or ", L = "choose from folder", y = "This is not a valid file type.", O = [];
  if ($)
    for (let U = 0; U < ($ == null ? void 0 : $.length); U++) {
      const X = Dr($[parseInt(`${U}`)].name), C = `filePreview_${X}`;
      O.push(
        /* @__PURE__ */ c(
          Ar,
          {
            imageId: X,
            file: $[parseInt(`${U}`)]
          },
          C
        )
      );
    }
  const D = g("usa-file-input__instructions", {
    "display-none": O.length > 0
  }), H = O.length > 1 ? `${O.length} files selected` : "Selected file", P = (U) => {
    if (x(!1), d) {
      const X = d.split(",");
      let C = !0;
      for (let R = 0; R < U.dataTransfer.files.length; R += 1) {
        const q = U.dataTransfer.files[parseInt(`${R}`)];
        if (C)
          for (let Q = 0; Q < X.length; Q += 1) {
            const re = X[parseInt(`${Q}`)];
            if (C = q.name.indexOf(re) > 0 || q.type.includes(re.replace(/\*/g, "")), C) break;
          }
        else break;
      }
      C || (p([]), x(!0), U.preventDefault(), U.stopPropagation());
    }
  }, j = () => M(!0), G = () => M(!1), ee = (U) => {
    P(U), M(!1), w && w(U);
  }, ie = (U) => {
    var C, R, q, Q;
    x(!1);
    const X = [];
    if ((R = (C = U.target) == null ? void 0 : C.files) != null && R.length) {
      const re = ((Q = (q = U.target) == null ? void 0 : q.files) == null ? void 0 : Q.length) || 0;
      for (let ve = 0; ve < re; ve++) {
        const de = U.target.files.item(ve);
        de && X.push(de);
      }
    }
    p(X), u && u(U);
  };
  return /* @__PURE__ */ c(
    "div",
    {
      "data-testid": "file-input",
      className: V,
      "aria-disabled": r,
      children: /* @__PURE__ */ z(
        "div",
        {
          "data-testid": "file-input-droptarget",
          className: E,
          onDragOver: j,
          onDragLeave: G,
          onDrop: ee,
          children: [
            O.length > 0 && /* @__PURE__ */ z(
              "div",
              {
                "data-testid": "file-input-preview-heading",
                className: "usa-file-input__preview-heading",
                children: [
                  H,
                  " ",
                  /* @__PURE__ */ z("span", { className: "usa-file-input__choose", children: [
                    "Change file",
                    O.length > 1 && "s"
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ z(
              "div",
              {
                "data-testid": "file-input-instructions",
                className: D,
                "aria-hidden": "true",
                children: [
                  !N && /* @__PURE__ */ c("span", { className: "usa-file-input__drag-text", children: a || S }),
                  /* @__PURE__ */ c("span", { className: "usa-file-input__choose", children: n || L })
                ]
              }
            ),
            O,
            /* @__PURE__ */ c("div", { "data-testid": "file-input-box", className: "usa-file-input__box" }),
            B && /* @__PURE__ */ c(
              "div",
              {
                "data-testid": "file-input-error",
                className: "usa-file-input__accepted-files-message",
                children: i || y
              }
            ),
            /* @__PURE__ */ c(
              "input",
              {
                ...f,
                ref: k,
                type: "file",
                "data-testid": "file-input-input",
                name: e,
                id: s,
                className: "usa-file-input__input",
                disabled: r,
                onChange: ie,
                multiple: o,
                accept: d
              }
            )
          ]
        }
      )
    }
  );
}, Rl = _e(Tr), Fr = ({
  onSubmit: e,
  children: s,
  className: a,
  large: n,
  search: i,
  ...r
}) => {
  const o = g(
    {
      "usa-form": !i,
      "usa-form--large": n
    },
    a
  );
  return /* @__PURE__ */ c(
    "form",
    {
      "data-testid": "form",
      className: o,
      onSubmit: e,
      ...r,
      children: s
    }
  );
}, Ul = ({
  children: e,
  className: s,
  error: a
}) => {
  const n = g(
    "usa-input-group",
    { "usa-input-group--error": a },
    s
  );
  return /* @__PURE__ */ c("div", { "data-testid": "inputGroup", className: n, children: e });
}, Yl = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-input-prefix", e);
  return /* @__PURE__ */ c(
    "div",
    {
      className: n,
      "aria-hidden": "true",
      ...a,
      "data-testid": "InputPrefix",
      children: s
    }
  );
}, Wl = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-input-suffix", e);
  return /* @__PURE__ */ c(
    "div",
    {
      className: n,
      "aria-hidden": "true",
      ...a,
      "data-testid": "InputSuffix",
      children: s
    }
  );
}, Lt = ({
  label: e,
  labelAttr: s,
  isOpen: a,
  onToggle: n,
  className: i,
  controls: r,
  ...o
}) => {
  const v = g("usa-button", "usa-language__link", i);
  return /* @__PURE__ */ c(
    "button",
    {
      "data-testid": "languageSelectorButton",
      className: v,
      "aria-expanded": a,
      "aria-controls": r,
      onClick: () => n(),
      type: "button",
      ...o,
      children: s ? /* @__PURE__ */ c("span", { lang: s, children: e }) : e
    }
  );
}, ke = ({
  items: e,
  type: s,
  className: a,
  ...n
}) => {
  const i = s === "primary", r = s === "secondary", o = s === "subnav", v = s === "megamenu", d = s === "footerSecondary", u = s === "language", w = g(
    {
      "usa-nav__primary usa-accordion": i,
      "usa-nav__secondary-links": r,
      "usa-nav__submenu": o,
      "usa-nav__submenu-list": v,
      "usa-list usa-list--unstyled": d,
      "usa-language__submenu": u
    },
    a
  ), f = g({
    "usa-nav__primary-item": i,
    "usa-nav__secondary-item": r,
    "usa-nav__submenu-item": o || v,
    "usa-footer__secondary-link": d,
    "usa-language__submenu-item": u
  });
  return /* @__PURE__ */ c("ul", { className: w, ...n, children: e.map((_, k) => /* @__PURE__ */ c("li", { className: f, children: _ }, `item_${k}`)) });
}, Pr = ({
  className: e,
  items: s,
  isOpen: a,
  type: n,
  ...i
}) => /* @__PURE__ */ c(
  ke,
  {
    className: e,
    items: s,
    type: n || "subnav",
    hidden: !a,
    ...i
  }
), Rr = (e) => e.map((s, a) => {
  const n = /* @__PURE__ */ z(se, { children: [
    /* @__PURE__ */ c("span", { lang: s.attr, children: /* @__PURE__ */ c("strong", { children: s.label }) }),
    s.label_local && ` (${s.label_local})`
  ] });
  return typeof s.on_click == "string" ? /* @__PURE__ */ c("a", { href: s.on_click, "data-testid": s.attr, children: n }, a) : /* @__PURE__ */ c(
    Se,
    {
      onClick: s.on_click,
      "data-testid": s.attr,
      type: "button",
      unstyled: !0,
      children: n
    },
    a
  );
}), Ur = ({
  label: e,
  langs: s,
  small: a,
  className: n,
  displayLang: i,
  ...r
}) => {
  const [o, v] = F(!1), d = g(
    "usa-language-container",
    {
      "usa-language--small": a !== void 0
    },
    n
  ), u = s.find((f) => f.attr === i), w = "language-options";
  return /* @__PURE__ */ c("div", { className: d, "data-testid": "languageSelector", ...r, children: /* @__PURE__ */ c("ul", { className: "usa-language__primary usa-accordion", children: /* @__PURE__ */ z("li", { className: "usa-language__primary-item", children: [
    /* @__PURE__ */ c(
      Lt,
      {
        className: d,
        label: (u == null ? void 0 : u.label) || e || s[0].label,
        isOpen: o,
        controls: w,
        onToggle: () => v((f) => !f)
      }
    ),
    /* @__PURE__ */ c(
      Pr,
      {
        items: Rr(s),
        isOpen: o,
        id: w,
        type: "language"
      }
    )
  ] }) }) });
}, Kl = ({
  label: e,
  langs: s,
  small: a,
  className: n,
  displayLang: i,
  ...r
}) => {
  const o = g(
    "usa-language-container",
    {
      "usa-language--small": a !== void 0
    },
    n
  ), [v, d] = F(!1);
  if (s.length > 2)
    return /* @__PURE__ */ c(Ur, { ...{ label: e, langs: s, small: a, displayLang: i }, className: n });
  {
    e && console.warn(
      "LanguageSelector's label is not used when only two languages are available."
    );
    const u = s.find((_) => _.attr === i) || s[Number(v)], w = typeof u.on_click == "string" ? u.on_click : "", f = typeof u.on_click == "string" ? () => {
      window.location.assign(w);
    } : u.on_click;
    return /* @__PURE__ */ c("div", { className: o, "data-testid": "languageSelector", ...r, children: /* @__PURE__ */ c(
      Lt,
      {
        className: o,
        label: u.label,
        labelAttr: u.attr,
        onToggle: () => {
          f(), i || d((_) => !_);
        }
      }
    ) });
  }
}, Il = ({
  id: e,
  name: s,
  className: a,
  label: n,
  inputRef: i,
  tile: r,
  labelDescription: o,
  ...v
}) => {
  const d = g("usa-radio", a), u = g("usa-radio__input", {
    "usa-radio__input--tile": r
  });
  return /* @__PURE__ */ z("div", { "data-testid": "radio", className: d, children: [
    /* @__PURE__ */ c(
      "input",
      {
        className: u,
        id: e,
        type: "radio",
        name: s,
        ref: i,
        ...v
      }
    ),
    /* @__PURE__ */ z("label", { className: "usa-radio__label", htmlFor: e, children: [
      n,
      o && /* @__PURE__ */ c("span", { className: "usa-checkbox__label-description", children: o })
    ] })
  ] });
}, Zl = ({
  className: e,
  inputRef: s,
  textPreposition: a,
  textUnit: n,
  ...i
}) => {
  const r = g("usa-range", e), o = 0, v = 100, d = Math.round(v / 2), u = "", w = "of", {
    min: f,
    max: _,
    defaultValue: k,
    value: b,
    ...M
  } = i, B = f || o, x = _ || v, $ = n || u, p = a || w, N = b !== void 0 ? b : k !== void 0 ? k : d, [A, V] = F(N), E = `${A} ${$} ${p} ${x}`;
  return /* @__PURE__ */ c(
    "input",
    {
      "data-testid": "range",
      "aria-valuetext": E,
      className: r,
      ref: s,
      type: "range",
      ...M,
      min: B,
      max: x,
      value: A,
      onChange: (S) => V(Number(S.target.value))
    }
  );
}, Gl = ({
  id: e,
  name: s,
  className: a,
  inputRef: n,
  children: i,
  validationStatus: r,
  ...o
}) => {
  const u = g(
    "usa-select",
    {
      "usa-input--error": r === "error",
      "usa-input--success": r === "success"
    },
    a
  );
  return /* @__PURE__ */ c(
    "select",
    {
      "data-testid": "Select",
      className: u,
      id: e,
      name: s,
      ref: n,
      ...o,
      children: i
    }
  );
};
function je(e, s, a) {
  const n = a || s, i = a ? e.replace(/\W/g, "") : e.replace(/\D/g, ""), r = (w) => !Number.isNaN(parseInt(w, 10)), o = (w) => w ? w.match(/[A-Z]/i) : !1, v = "_#dDmMyY9", d = "A";
  let u = "";
  for (let w = 0, f = 0; w < n.length; w++) {
    const _ = r(i[f]), k = o(i[f]), b = v.indexOf(n[w]) >= 0, M = d.indexOf(n[w]) >= 0;
    if (b && _ || a && M && k)
      u += i[f++];
    else {
      if (i[f] === void 0 || // if no characters left and the pattern is non-special character
      !a && !_ && b || a && (M && !k || b && !k))
        break;
      u += n[w];
    }
  }
  return u;
}
const jl = ({
  id: e,
  className: s,
  mask: a,
  value: n,
  defaultValue: i,
  charset: r,
  onChange: o,
  ...v
}) => {
  const d = g(
    {
      "usa-masked": a
    },
    s
  ), [u, w] = F(
    // Ensure that this component preserves the expected behavior when a user sets the defaultValue
    je(n ?? i ?? "", a, r)
  );
  Z(() => {
    w(
      je(
        n ?? i ?? "",
        a,
        r
      )
    );
  }, [n]);
  const [f, _] = F(a.substring(u.length)), k = (b) => {
    const M = je(b.target.value, a, r);
    _(a.substring(M.length)), w(M), b.target.value = M, o == null || o(b);
  };
  return /* @__PURE__ */ z("span", { className: "usa-input-mask", children: [
    /* @__PURE__ */ z(
      "span",
      {
        className: "usa-input-mask--content",
        "aria-hidden": !0,
        "data-testid": `${e}Mask`,
        children: [
          /* @__PURE__ */ c("i", { children: u }),
          f
        ]
      }
    ),
    /* @__PURE__ */ c(
      Ve,
      {
        "data-testid": "textInput",
        className: d,
        id: e,
        maxLength: a.length,
        onChange: k,
        value: u,
        ...v
      }
    )
  ] });
}, Mt = (e) => {
  let s;
  if (e) {
    const [a, n] = e.split(":").map((i) => {
      let r;
      const o = parseInt(i, 10);
      return Number.isNaN(o) || (r = o), r;
    });
    a != null && n != null && (s = a * 60 + n);
  }
  return s;
}, Yr = (e) => {
  const s = e % 60, a = Math.floor(e / 60), n = a % 12 || 12, i = a < 12 ? "am" : "pm";
  return {
    minute: s,
    hour24: a,
    hour12: n,
    ampm: i
  };
}, qe = (e, s) => `0000${e}`.slice(-s), Wr = (e, s, a) => {
  const n = [];
  for (let i = e; i <= s; i += a) {
    const { minute: r, hour24: o, hour12: v, ampm: d } = Yr(i);
    n.push({
      value: `${qe(o, 2)}:${qe(r, 2)}`,
      label: `${v}:${qe(r, 2)}${d}`
    });
  }
  return n;
}, Kr = "23:59", Ir = 24 * 60 - 1, Zr = "00:00", Gr = 0, jr = 30, xt = 1, qr = {
  filter: "0?{{ hourQueryFilter }}:{{minuteQueryFilter}}.*{{ apQueryFilter }}m?",
  extras: {
    apQueryFilter: "([ap])",
    hourQueryFilter: "([1-9][0-2]?)",
    minuteQueryFilter: "[\\d]+:([0-9]{0,2})"
  }
}, ql = ({
  id: e,
  name: s,
  onChange: a,
  label: n,
  defaultValue: i,
  disabled: r,
  minTime: o = Zr,
  maxTime: v = Kr,
  step: d = jr,
  hint: u,
  className: w
}) => {
  const f = g("usa-time-picker", w), _ = Mt(o) || Gr, k = Mt(v) || Ir, b = d < xt ? xt : d, M = At(
    () => Wr(_, k, b),
    [o, v, d]
  ), B = `${s}-label`, x = `${s}-hint`;
  return /* @__PURE__ */ z(Pe, { children: [
    /* @__PURE__ */ c(He, { className: "usa-label", id: B, htmlFor: e, children: n }),
    u && /* @__PURE__ */ c("div", { className: "usa-hint", id: x, children: u }),
    /* @__PURE__ */ c(
      Er,
      {
        id: e,
        name: s,
        className: f,
        onChange: a,
        defaultValue: i,
        options: M,
        disabled: r,
        customFilter: qr,
        disableFiltering: !0
      }
    )
  ] });
}, Ql = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g(s, "usa-checklist");
  return /* @__PURE__ */ c("ul", { className: n, "data-testid": "validationChecklist", ...a, children: e });
}, Jl = ({
  children: e,
  className: s,
  isValid: a,
  ...n
}) => {
  const i = g(
    "usa-checklist__item",
    { "usa-checklist__item--checked": a },
    s
  );
  return /* @__PURE__ */ c("li", { className: i, ...n, children: e });
}, kt = ({
  onClick: e,
  className: s,
  ...a
}) => {
  const n = g("usa-nav__close", s);
  return /* @__PURE__ */ c(
    "button",
    {
      className: n,
      onClick: e,
      "data-testid": "navCloseButton",
      "aria-label": "Close Navigation Menu",
      ...a,
      type: "button",
      children: /* @__PURE__ */ c(ae.Close, { size: 3, "aria-hidden": "true" })
    }
  );
}, Xl = ({
  primaryItems: e,
  secondaryItems: s,
  mobileExpanded: a = !1,
  children: n,
  className: i,
  onToggleMobileNav: r,
  ...o
}) => {
  const v = g(
    "usa-nav",
    {
      "is-visible": a
    },
    i
  );
  return /* @__PURE__ */ c("nav", { className: v, ...o, children: /* @__PURE__ */ z("div", { className: "usa-nav__inner", children: [
    /* @__PURE__ */ c(kt, { onClick: r }),
    /* @__PURE__ */ c(ke, { items: e, type: "primary" }),
    /* @__PURE__ */ z("div", { className: "usa-nav__secondary", children: [
      /* @__PURE__ */ c(ke, { items: s, type: "secondary" }),
      n
    ] })
  ] }) });
}, e4 = ({
  basic: e,
  extended: s,
  basicWithMegaMenu: a,
  children: n,
  showMobileOverlay: i,
  className: r,
  ...o
}) => {
  const v = g(
    "usa-header",
    {
      "usa-header--basic": e,
      "usa-header--megamenu": a,
      "usa-header--extended": s
    },
    r
  ), d = g("usa-overlay", {
    "is-visible": i
  });
  return /* @__PURE__ */ z(se, { children: [
    i !== void 0 && /* @__PURE__ */ c("div", { className: d, "data-testid": "overlay" }),
    /* @__PURE__ */ c("header", { "data-testid": "header", className: v, ...o, children: n })
  ] });
}, t4 = ({
  items: e,
  isOpen: s,
  className: a,
  ...n
}) => {
  const i = g("usa-nav__submenu usa-megamenu", a);
  return /* @__PURE__ */ c("div", { className: i, hidden: !s, "data-testid": "megamenu", children: /* @__PURE__ */ c("div", { className: "grid-row grid-gap-4", children: e.map((r, o) => /* @__PURE__ */ c("div", { className: "usa-col", children: /* @__PURE__ */ c(ke, { items: r, type: "megamenu", ...n }) }, `subnav_col_${o}`)) }) });
}, s4 = ({
  label: e,
  onClick: s,
  ...a
}) => /* @__PURE__ */ c(
  "button",
  {
    className: "usa-menu-btn",
    onClick: s,
    "data-testid": "navMenuButton",
    ...a,
    type: "button",
    children: e
  }
), a4 = ({
  label: e,
  menuId: s,
  isOpen: a,
  onToggle: n,
  isCurrent: i,
  className: r,
  ...o
}) => {
  const v = g(
    "usa-accordion__button",
    "usa-nav__link",
    {
      "usa-current": i
    },
    r
  );
  return /* @__PURE__ */ c(
    "button",
    {
      "data-testid": "navDropDownButton",
      className: v,
      "aria-expanded": a,
      "aria-controls": s,
      onClick: () => n(),
      ...o,
      type: "button",
      children: /* @__PURE__ */ c("span", { children: e })
    }
  );
}, n4 = ({
  items: e,
  onToggleMobileNav: s,
  mobileExpanded: a,
  children: n,
  className: i,
  ...r
}) => {
  const o = g(
    "usa-nav",
    {
      "is-visible": a
    },
    i
  );
  return /* @__PURE__ */ z("nav", { className: o, ...r, children: [
    /* @__PURE__ */ c(kt, { onClick: s }),
    /* @__PURE__ */ c(ke, { items: e, type: "primary" }),
    n
  ] });
}, c4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-logo", e);
  return /* @__PURE__ */ c("div", { className: n, ...a, children: /* @__PURE__ */ c("em", { className: "usa-logo__text", children: s }) });
}, i4 = ({
  children: e,
  className: s
}) => {
  const a = g(s, "usa-icon-list");
  return /* @__PURE__ */ c("ul", { className: a, "data-testid": "iconList", children: e });
}, o4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g(e, "usa-icon-list__content");
  return /* @__PURE__ */ c("div", { className: n, ...a, "data-testid": "iconListContent", children: s });
}, r4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g(e, "usa-icon-list__icon");
  return /* @__PURE__ */ c("div", { className: n, ...a, "data-testid": "iconListIcon", children: s });
}, l4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g(e, "usa-icon-list__item");
  return /* @__PURE__ */ c("li", { className: n, ...a, "data-testid": "iconListItem", children: s });
}, h4 = ({
  type: e,
  children: s,
  className: a
}) => {
  const n = g(a, "usa-icon-list__title");
  return /* @__PURE__ */ c(e, { className: n, "data-testid": "iconListTitle", children: s });
}, m4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-identifier", e);
  return /* @__PURE__ */ c("div", { "data-testid": "identifier", className: n, ...a, children: s });
}, d4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g(
    "usa-identifier__section usa-identifier__section--usagov",
    s
  );
  return /* @__PURE__ */ c("section", { "data-testid": "identifierGov", className: n, ...a, children: /* @__PURE__ */ c("div", { className: "usa-identifier__container", children: e }) });
}, v4 = ({
  children: e,
  domain: s,
  className: a,
  ...n
}) => {
  const i = g("usa-identifier__identity", a);
  return /* @__PURE__ */ z("div", { "data-testid": "identifierIdentity", className: i, ...n, children: [
    /* @__PURE__ */ c("p", { className: "usa-identifier__identity-domain", children: s }),
    /* @__PURE__ */ c("p", { className: "usa-identifier__identity-disclaimer", children: e })
  ] });
};
function g4({
  className: e,
  ...s
}) {
  const a = g(e, "usa-identifier__required-link"), n = {
    ...s,
    className: a
  };
  return Ye(n) ? /* @__PURE__ */ c(ue, { ...n }) : /* @__PURE__ */ c(ue, { ...n });
}
const u4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-identifier__required-links-item", s);
  return /* @__PURE__ */ c("li", { className: n, ...a, children: e });
}, w4 = ({
  children: e,
  className: s,
  navProps: a,
  listProps: n
}) => {
  const i = g(
    "usa-identifier__section usa-identifier__section--required-links",
    s
  );
  return /* @__PURE__ */ c("nav", { className: i, ...a, children: /* @__PURE__ */ c("div", { className: "usa-identifier__container", children: /* @__PURE__ */ c("ul", { className: "usa-identifier__required-links-list", ...n, children: e }) }) });
}, p4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-identifier__logo", s);
  return /* @__PURE__ */ c("a", { className: n, ...a, children: e });
}, f4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-identifier__logos", s);
  return /* @__PURE__ */ c("div", { "data-testid": "identifierLogos", className: n, ...a, children: e });
}, M4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g(
    "usa-identifier__section usa-identifier__section--masthead",
    e
  );
  return /* @__PURE__ */ c(
    "section",
    {
      "data-testid": "identifierMasthead",
      className: n,
      ...a,
      children: /* @__PURE__ */ c("div", { className: "usa-identifier__container", children: s })
    }
  );
}, x4 = ({
  size: e,
  className: s,
  items: a
}) => {
  const n = e === "big", i = e === "medium", r = e === "slim", o = g("usa-footer__address", s), v = g({
    "grid-col-auto": n || i,
    "grid-col-auto mobile-lg:grid-col-12 desktop:grid-col-auto": r
  });
  return /* @__PURE__ */ c("address", { className: o, children: r ? /* @__PURE__ */ c("div", { className: "grid-row grid-gap", children: a.map((d, u) => /* @__PURE__ */ c("div", { className: v, children: /* @__PURE__ */ c("div", { className: "usa-footer__contact-info", children: d }) }, `addressItem-${u}`)) }) : /* @__PURE__ */ c("div", { className: "usa-footer__contact-info grid-row grid-gap", children: a.map((d, u) => /* @__PURE__ */ c("div", { className: v, children: d }, `addressItem-${u}`)) }) });
}, E4 = ({
  size: e,
  returnToTop: s,
  primary: a,
  secondary: n,
  ...i
}) => {
  const r = g(
    "usa-footer",
    {
      "usa-footer--big": e === "big",
      "usa-footer--medium": e === "medium",
      "usa-footer--slim": e === "slim"
    },
    i.className
  );
  return /* @__PURE__ */ z("footer", { ...i, className: r, children: [
    s && s,
    /* @__PURE__ */ c("div", { className: "usa-footer__primary-section", children: a }),
    /* @__PURE__ */ c("div", { className: "usa-footer__secondary-section", children: /* @__PURE__ */ c("div", { className: "grid-container", children: n }) })
  ] });
}, Qr = ({
  className: e,
  isMobile: s,
  nestedLinks: a
}) => {
  const n = g("grid-row grid-gap-4", e), i = window && typeof window == "object", [r, o] = ze.useState(
    i && window.innerWidth < 480
  ), [v, d] = F(
    Array(a.length).fill(!1)
  ), u = s || s === void 0 && r;
  Z(() => {
    if (s) return;
    function f() {
      const _ = i && window.innerWidth < 480;
      _ !== r && o(_);
    }
    return window.addEventListener("resize", f), () => window.removeEventListener("resize", f);
  }, []);
  const w = (f) => {
    d((_) => {
      const k = Array(a.length).fill(!1);
      return k[f] = !_[f], k;
    });
  };
  return /* @__PURE__ */ c("div", { className: n, children: a.map((f, _) => /* @__PURE__ */ c(
    "div",
    {
      className: "mobile-lg:grid-col-6 desktop:grid-col-3",
      children: /* @__PURE__ */ c(
        Jr,
        {
          onToggle: u ? () => w(_) : void 0,
          isOpen: u ? v[_] : !0,
          links: f
        }
      )
    },
    `linkSection-${_}`
  )) });
}, Jr = ({
  isOpen: e = !1,
  links: s,
  onToggle: a
}) => {
  const [n, ...i] = s, r = g(
    "usa-footer__primary-content usa-footer__primary-content--collapsible",
    { hidden: !e }
  );
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ z("section", { className: r, onClick: a, onKeyPress: a, children: [
      /* @__PURE__ */ c("h4", { className: "usa-footer__primary-link", children: n }),
      /* @__PURE__ */ c(ke, { type: "footerSecondary", items: i })
    ] })
  );
};
function Et(e) {
  return e[0].constructor === Array;
}
const b4 = ({
  className: e,
  size: s,
  isMobile: a,
  links: n,
  ...i
}) => {
  const r = s === "big", o = s === "medium", v = s === "slim", d = g("usa-footer__nav", e), u = g(
    "desktop:grid-col-auto usa-footer__primary-content",
    {
      "mobile-lg:grid-col-4": r || o,
      "mobile-lg:grid-col-6": v
    }
  );
  return /* @__PURE__ */ z("nav", { className: d, ...i, children: [
    r && Et(n) && /* @__PURE__ */ c(Qr, { isMobile: a, nestedLinks: n }),
    !Et(n) && /* @__PURE__ */ c("ul", { className: "grid-row grid-gap", children: n.map((w, f) => /* @__PURE__ */ c("li", { className: u, children: w }, `navLink-${f}`)) })
  ] });
}, z4 = ({
  size: e,
  heading: s,
  image: a,
  ...n
}) => {
  const i = e === "big", r = e === "medium", o = e === "slim", v = g(
    "usa-footer__logo grid-row",
    {
      "mobile-lg:grid-col-6 mobile-lg:grid-gap-2": i || r,
      "grid-gap-2": o
    },
    n.className
  ), d = g({
    "mobile-lg:grid-col-auto": i || r,
    "grid-col-auto": o
  });
  return /* @__PURE__ */ c("div", { className: v, "data-testid": "footerLogo", children: /* @__PURE__ */ z(se, { children: [
    /* @__PURE__ */ c("div", { className: d, children: a }),
    s && /* @__PURE__ */ c("div", { className: d, children: s })
  ] }) });
}, S4 = ({
  className: e,
  links: s
}) => {
  const a = g(
    "usa-footer__social-links grid-row grid-gap-1",
    e
  );
  return /* @__PURE__ */ c("div", { className: a, children: s.map((n, i) => /* @__PURE__ */ c("div", { className: "grid-col-auto", children: n }, `socialLink${i}`)) });
}, _4 = ({
  name: e,
  ...s
}) => {
  let a;
  switch (e) {
    case "Facebook":
      a = ae.Facebook;
      break;
    case "Twitter":
      a = ae.Twitter;
      break;
    case "YouTube":
      a = ae.Youtube;
      break;
    case "Instagram":
      a = ae.Instagram;
      break;
    case "RSS":
      a = ae.RssFeed;
      break;
  }
  return /* @__PURE__ */ c("a", { className: "usa-social-link", ...s, title: e, children: a && /* @__PURE__ */ c(
    a,
    {
      className: "usa-social-link__icon",
      name: e,
      "aria-hidden": "true"
    }
  ) });
}, Xr = (e) => {
  const [s, a] = F(e || !1), n = (r) => {
    const o = r.target;
    return r && o && o.closest(".usa-modal") ? o.hasAttribute("[data-close-modal]") || !!o.closest("[data-close-modal]") : !0;
  };
  return { isOpen: s, toggleModal: (r, o) => r && !n(r) ? (r.stopPropagation(), !1) : (a(o === !0 ? !0 : o === !1 ? !1 : (v) => !v), !0) };
}, el = () => {
  var e;
  if (typeof document < "u") {
    const s = document.createElement("div");
    s.setAttribute(
      "style",
      "visibility: hidden; overflow: scroll; ms-overflow-style: scrollbar"
    ), document.body.appendChild(s);
    const a = document.createElement("div");
    s.appendChild(a);
    const n = `${s.offsetWidth - a.offsetWidth}px`;
    return (e = s.parentNode) == null || e.removeChild(s), n;
  }
  return "";
}, tl = ({
  handleClose: e,
  ...s
}) => /* @__PURE__ */ c(
  Se,
  {
    "aria-label": "Close this window",
    ...s,
    className: "usa-modal__close",
    onClick: e,
    "data-close-modal": !0,
    type: "button",
    children: /* @__PURE__ */ c(ae.Close, { "aria-hidden": "true" })
  }
), sl = ({
  modalId: e,
  className: s,
  children: a,
  handleClose: n,
  isLarge: i = !1,
  forceAction: r = !1,
  ...o
}, v) => {
  const d = g(
    "usa-modal",
    {
      "usa-modal--lg": i
    },
    s
  );
  return /* @__PURE__ */ c(
    "div",
    {
      ...o,
      "data-testid": "modalWindow",
      className: d,
      ref: v,
      "data-force-action": r,
      children: /* @__PURE__ */ z("div", { className: "usa-modal__content", children: [
        /* @__PURE__ */ c("div", { className: "usa-modal__main", children: a }),
        !r && /* @__PURE__ */ c(tl, { "aria-controls": e, handleClose: n })
      ] })
    }
  );
}, al = _e(sl), nl = ({ id: e, children: s, isVisible: a, forceAction: n, className: i, handleClose: r, ...o }, v) => {
  const d = g(
    "usa-modal-wrapper",
    {
      "is-visible": a,
      "is-hidden": !a
    },
    i
  );
  return /* @__PURE__ */ c("div", { ...o, ref: v, id: e, className: d, role: "dialog", children: /* @__PURE__ */ c(
    "div",
    {
      "data-testid": "modalOverlay",
      className: "usa-modal-overlay",
      onClick: n ? void 0 : r,
      "aria-controls": e,
      children: s
    }
  ) });
}, cl = _e(nl), il = ({
  id: e,
  children: s,
  isLarge: a = !1,
  forceAction: n = !1,
  modalRoot: i = ".usa-modal-wrapper",
  renderToPortal: r = !0,
  isInitiallyOpen: o,
  ...v
}, d) => {
  const { isOpen: u, toggleModal: w } = Xr(o), [f, _] = F(!1), k = K(), b = K(), M = K(null), x = `body > *:not(${i || ".usa-modal-wrapper"}):not([aria-hidden])`, $ = "[data-modal-hidden]", p = (O) => {
    w(O, !1);
  };
  et(
    d,
    () => ({
      modalId: e,
      modalIsOpen: u,
      toggleModal: w
    }),
    [e, u]
  );
  const N = () => {
    const { body: O } = document;
    O.style.paddingRight = b.current || "", O.classList.add("usa-js-modal--active"), document.querySelectorAll(x).forEach((D) => {
      D.setAttribute("aria-hidden", "true"), D.setAttribute("data-modal-hidden", "");
    }), n && O.classList.add("usa-js-no-click");
  }, A = () => {
    const { body: O } = document;
    O.style.paddingRight = k.current || "", O.classList.remove("usa-js-modal--active"), O.classList.remove("usa-js-no-click"), document.querySelectorAll($).forEach((D) => {
      D.removeAttribute("aria-hidden"), D.removeAttribute("data-modal-hidden");
    });
  };
  Z(() => {
    const O = el(), D = window.getComputedStyle(document.body).getPropertyValue("padding-right") || "0px", H = `${parseInt(D.replace(/px/, ""), 10) + parseInt(O.replace(/px/, ""), 10)}px`;
    return k.current = D, b.current = H, _(!0), () => {
      A();
    };
  }, []), Z(() => {
    f && (u === !0 ? N() : u === !1 && A());
  }, [u]);
  const V = v["aria-labelledby"], E = v["aria-describedby"];
  V || console.error(`${e} is missing aria-labelledby attribute`), E || console.error(`${e} is missing aria-describedby attribute`), delete v["aria-labelledby"], delete v["aria-describedby"];
  const y = /* @__PURE__ */ c(Dt, { active: u, focusTrapOptions: {
    initialFocus: () => {
      var D;
      const O = (D = M.current) == null ? void 0 : D.querySelector("[data-focus]");
      return O || M.current || !1;
    },
    escapeDeactivates: () => n ? !1 : (p(), !0)
  }, children: /* @__PURE__ */ c(
    cl,
    {
      role: "dialog",
      id: e,
      "aria-labelledby": V,
      "aria-describedby": E,
      "data-force-action": n,
      isVisible: u,
      handleClose: p,
      forceAction: n,
      children: /* @__PURE__ */ c(
        al,
        {
          modalId: e,
          ...v,
          ref: M,
          isLarge: a,
          forceAction: n,
          tabIndex: -1,
          handleClose: p,
          children: s
        }
      )
    }
  ) });
  if (r) {
    const D = document.getElementById("modal-root") || document.body;
    return Tt.createPortal(y, D);
  } else
    return y;
}, C4 = _e(il), N4 = ({
  modalRef: e,
  children: s,
  opener: a,
  closer: n,
  ...i
}) => {
  var v;
  const r = (d) => {
    if (!e || !e.current)
      return console.error("ModalRef is required"), !1;
    i.onClick && i.onClick(d), a && !n ? e.current.toggleModal(d, !0) : n && !a ? e.current.toggleModal(d, !1) : e.current.toggleModal(d);
  }, o = {
    "data-close-modal": !0,
    "data-open-modal": !0
  };
  return a && !n && delete o["data-close-modal"], n && !a && delete o["data-open-modal"], /* @__PURE__ */ c(
    Se,
    {
      ...i,
      ...o,
      type: "button",
      "aria-controls": (v = e == null ? void 0 : e.current) == null ? void 0 : v.modalId,
      onClick: r,
      children: s
    }
  );
};
function y4({
  modalRef: e,
  ...s
}) {
  var r;
  const a = (o) => {
    if (!e || !e.current)
      return console.error("ModalRef is required"), !1;
    o.preventDefault(), e.current.toggleModal(o, !0);
  }, n = {
    ...s,
    role: "button",
    "aria-controls": (r = e == null ? void 0 : e.current) == null ? void 0 : r.modalId,
    "data-open-modal": !0,
    onClick: a
  };
  return Ye(n) ? /* @__PURE__ */ c(ue, { ...n }) : /* @__PURE__ */ c(ue, { ...n });
}
const L4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-modal__heading", e);
  return /* @__PURE__ */ c("h2", { className: n, ...a, children: s });
}, k4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-modal__footer", s);
  return /* @__PURE__ */ c("div", { className: n, "data-testid": "modalFooter", ...a, children: e });
}, $4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-card-group", s);
  return /* @__PURE__ */ c("ul", { className: n, "data-testid": "CardGroup", ...a, children: e });
}, H4 = ({
  layout: e = "standardDefault",
  headerFirst: s,
  children: a,
  className: n,
  gridLayout: i,
  containerProps: r,
  ...o
}) => {
  const { className: v, ...d } = r || {}, u = i && dr(i), w = g(
    "usa-card",
    {
      "usa-card--header-first": s,
      "usa-card--flag": e === "flagDefault" || e === "flagMediaRight",
      "usa-card--media-right": e === "flagMediaRight"
    },
    u,
    n
  ), f = g("usa-card__container", v);
  return /* @__PURE__ */ c("li", { className: w, "data-testid": "Card", ...o, children: /* @__PURE__ */ c("div", { className: f, ...d, children: a }) });
}, V4 = ({
  exdent: e,
  children: s,
  className: a,
  ...n
}) => {
  const i = g(
    "usa-card__header",
    {
      "usa-card__header--exdent": e
    },
    a
  );
  return /* @__PURE__ */ c("div", { className: i, ...n, "data-testid": "CardHeader", children: s });
}, B4 = ({
  exdent: e,
  inset: s,
  imageClass: a,
  children: n,
  className: i,
  ...r
}) => {
  const o = g(
    "usa-card__media",
    {
      "usa-card__media--exdent": e,
      "usa-card__media--inset": s
    },
    i
  ), v = g("usa-card__img", a);
  return /* @__PURE__ */ c("div", { className: o, ...r, "data-testid": "CardMedia", children: /* @__PURE__ */ c("div", { className: v, children: n }) });
}, O4 = ({
  exdent: e,
  children: s,
  className: a,
  ...n
}) => {
  const i = g(
    "usa-card__body",
    {
      "usa-card__body--exdent": e
    },
    a
  );
  return /* @__PURE__ */ c("div", { className: i, ...n, "data-testid": "CardBody", children: s });
}, A4 = ({
  exdent: e,
  children: s,
  className: a,
  ...n
}) => {
  const i = g(
    "usa-card__footer",
    {
      "usa-card__footer--exdent": e
    },
    a
  );
  return /* @__PURE__ */ c("div", { className: i, ...n, "data-testid": "CardFooter", children: s });
}, D4 = ({
  variant: e = "default",
  children: s,
  className: a,
  navProps: n,
  listProps: i
}) => {
  const r = g(
    "usa-breadcrumb",
    {
      "usa-breadcrumb--wrap": e === "wrap"
    },
    a
  );
  return /* @__PURE__ */ c("nav", { className: r, "aria-label": "Breadcrumbs", ...n, children: /* @__PURE__ */ c("ol", { className: "usa-breadcrumb__list", ...i, children: s }) });
}, T4 = ({
  children: e,
  current: s = !1,
  className: a,
  ...n
}) => {
  const i = g(
    "usa-breadcrumb__list-item",
    {
      "usa-current": s
    },
    a
  );
  return /* @__PURE__ */ c(
    "li",
    {
      className: i,
      "aria-current": s ? "page" : void 0,
      ...n,
      children: e
    }
  );
};
function F4({
  className: e,
  ...s
}) {
  const a = g(e, "usa-breadcrumb__link"), n = {
    ...s,
    className: a
  };
  return Ye(n) ? /* @__PURE__ */ c(ue, { ...n, variant: "unstyled" }) : /* @__PURE__ */ c(ue, { ...n, variant: "unstyled" });
}
const P4 = (e) => {
  const {
    showLabels: s = !0,
    counters: a = "none",
    centered: n = !1,
    children: i,
    className: r,
    divProps: o,
    listProps: v,
    headingProps: d,
    headingLevel: u,
    stepText: w = "Step",
    ofText: f = "of",
    statusText: _ = { complete: "completed", incomplete: "not completed" }
  } = e, k = u, { className: b, ...M } = o || {}, { className: B, ...x } = v || {}, { className: $, ...p } = d || {}, N = g(
    "usa-step-indicator",
    {
      "usa-step-indicator--no-labels": !s,
      "usa-step-indicator--counters": a === "default",
      "usa-step-indicator--counters-sm": a === "small",
      "usa-step-indicator--center": n
    },
    r,
    b
  ), A = g(
    "usa-step-indicator__segments",
    B
  ), V = g(
    "usa-step-indicator__heading",
    $
  ), S = (() => {
    const H = i.findIndex((P) => P.props.status === "current");
    return H === -1 ? 0 : H;
  })(), L = S + 1, y = i[parseInt(`${S}`)].props.label, O = i.length, D = ze.Children.map(
    i,
    (H) => ze.cloneElement(H, { statusText: _ })
  );
  return /* @__PURE__ */ z(
    "div",
    {
      className: N,
      "data-testid": "step-indicator",
      "aria-label": "progress",
      ...M,
      children: [
        /* @__PURE__ */ c("ol", { className: A, ...x, children: D }),
        /* @__PURE__ */ c("div", { className: "usa-step-indicator__header", children: /* @__PURE__ */ z(k, { className: V, ...p, children: [
          /* @__PURE__ */ z("span", { className: "usa-step-indicator__heading-counter", children: [
            /* @__PURE__ */ c("span", { className: "usa-sr-only", "data-testid": "step-text", children: w }),
            /* @__PURE__ */ c("span", { className: "usa-step-indicator__current-step", children: L }),
            " ",
            /* @__PURE__ */ c("span", { className: "usa-step-indicator__total-steps", children: `${f} ${O}` }),
            " "
          ] }),
          /* @__PURE__ */ c("span", { className: "usa-step-indicator__heading-text", children: y })
        ] }) })
      ]
    }
  );
}, R4 = (e) => {
  const {
    label: s,
    status: a = "incomplete",
    statusText: n = { complete: "completed", incomplete: "not completed" },
    className: i,
    ...r
  } = e, o = g(
    "usa-step-indicator__segment",
    {
      "usa-step-indicator__segment--complete": a === "complete",
      "usa-step-indicator__segment--current": a === "current"
    },
    i
  );
  return /* @__PURE__ */ c(
    "li",
    {
      className: o,
      "aria-current": a === "current" ? "true" : void 0,
      ...r,
      children: /* @__PURE__ */ z("span", { className: "usa-step-indicator__segment-label", children: [
        s,
        " ",
        a !== "current" && /* @__PURE__ */ c("span", { "data-testid": "srStatusText", className: "usa-sr-only", children: a === "complete" ? n.complete : n.incomplete })
      ] })
    }
  );
}, ol = ({
  isBig: e,
  className: s,
  placeholder: a,
  defaultValue: n,
  inputName: i = "search",
  label: r = "Search",
  inputId: o = "search-field",
  inputProps: v
}) => {
  const d = g(
    {
      "usa-search--big": e
    },
    s
  );
  return /* @__PURE__ */ z("div", { className: d, "data-testid": "searchField", children: [
    /* @__PURE__ */ c(He, { srOnly: !0, htmlFor: o, children: r }),
    /* @__PURE__ */ c(
      Ve,
      {
        ...v,
        id: o,
        name: i,
        type: "search",
        placeholder: a,
        defaultValue: n
      }
    )
  ] });
}, rl = ({
  size: e,
  className: s,
  i18n: a,
  buttonAriaLabel: n
}) => {
  const i = (a == null ? void 0 : a.buttonText) || "Search", r = e === "small", v = g(
    {
      "usa-search--small": r,
      "usa-search--big": e === "big"
    },
    s
  );
  return /* @__PURE__ */ c("div", { className: v, children: /* @__PURE__ */ z(Se, { "aria-label": n || i, type: "submit", children: [
    !r && /* @__PURE__ */ c("span", { className: "usa-search__submit-text", children: i }),
    /* @__PURE__ */ c(
      ae.Search,
      {
        className: "usa-search__submit-icon",
        name: i,
        size: 3,
        "aria-hidden": !0
      }
    )
  ] }) });
}, U4 = ({
  onSubmit: e,
  size: s,
  className: a,
  placeholder: n,
  inputName: i = "search",
  label: r = "Search",
  inputId: o = "search-field",
  i18n: v,
  buttonAriaLabel: d,
  inputProps: u,
  ...w
}) => {
  const f = g("usa-search", a);
  return /* @__PURE__ */ z(
    Fr,
    {
      onSubmit: e,
      className: f,
      role: "search",
      search: !0,
      ...w,
      children: [
        /* @__PURE__ */ c(
          ol,
          {
            ...u,
            isBig: s == "big",
            inputId: o,
            placeholder: n,
            name: i,
            label: r,
            defaultValue: w.defaultValue
          }
        ),
        /* @__PURE__ */ c(rl, { size: s, i18n: v, buttonAriaLabel: d })
      ]
    }
  );
}, Y4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-summary-box", s);
  return /* @__PURE__ */ c("div", { className: n, "data-testid": "summary-box", ...a, children: /* @__PURE__ */ c("div", { className: "usa-summary-box__body", children: e }) });
}, W4 = ({
  children: e,
  className: s,
  headingLevel: a,
  ...n
}) => {
  const i = g("usa-summary-box__heading", s);
  return /* @__PURE__ */ c(a, { className: i, ...n, children: e });
}, K4 = ({
  children: e,
  className: s,
  ...a
}) => {
  const n = g("usa-summary-box__text", s);
  return /* @__PURE__ */ c("div", { className: n, ...a, children: e });
}, I4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-process-list", e);
  return /* @__PURE__ */ c("ol", { className: n, ...a, children: s });
}, Z4 = ({
  className: e,
  children: s,
  ...a
}) => {
  const n = g("usa-process-list__item", e);
  return /* @__PURE__ */ c("li", { className: n, ...a, children: s });
}, G4 = ({
  type: e,
  className: s,
  children: a,
  ...n
}) => {
  const i = g("usa-process-list__heading", s);
  return /* @__PURE__ */ c(e, { "data-testid": "processListHeading", className: i, ...n, children: a });
}, j4 = ({
  variant: e,
  children: s,
  heading: a,
  showIcon: n = !0,
  slim: i = !1,
  className: r,
  ...o
}) => {
  const v = g(
    "usa-site-alert",
    {
      "usa-site-alert--info": e === "info",
      "usa-site-alert--emergency": e === "emergency",
      "usa-site-alert--no-heading": a === void 0 && !i,
      "usa-site-alert--no-icon": !n,
      "usa-site-alert--slim": i
    },
    r
  );
  let d = s;
  return typeof s == "string" && (d = /* @__PURE__ */ c("p", { className: "usa-alert__text", children: s })), /* @__PURE__ */ c(
    "section",
    {
      "data-testid": "siteAlert",
      className: v,
      "aria-label": "Site alert",
      ...o,
      children: /* @__PURE__ */ c("div", { className: "usa-alert", children: /* @__PURE__ */ z("div", { className: "usa-alert__body", children: [
        a && /* @__PURE__ */ c("h3", { className: "usa-alert__heading", children: a }),
        d
      ] }) })
    }
  );
};
export {
  gl as Accordion,
  x4 as Address,
  vl as Alert,
  er as Banner,
  tr as BannerButton,
  sr as BannerContent,
  ar as BannerFlag,
  ht as BannerGuidance,
  nr as BannerHeader,
  mt as BannerIcon,
  T4 as Breadcrumb,
  D4 as BreadcrumbBar,
  F4 as BreadcrumbLink,
  Se as Button,
  ul as ButtonGroup,
  H4 as Card,
  O4 as CardBody,
  A4 as CardFooter,
  $4 as CardGroup,
  V4 as CardHeader,
  B4 as CardMedia,
  Bl as CharacterCount,
  Ol as Checkbox,
  zl as Collection,
  $l as CollectionCalendarDate,
  Cl as CollectionDescription,
  _l as CollectionHeading,
  Sl as CollectionItem,
  Nl as CollectionMeta,
  yl as CollectionMetaItem,
  Ll as CollectionMetaItemTag,
  kl as CollectionThumbnail,
  Er as ComboBox,
  Al as DateInput,
  Dl as DateInputGroup,
  pt as DatePicker,
  Tl as DateRangePicker,
  Fl as ErrorMessage,
  Xl as ExtendedNav,
  Pl as Fieldset,
  Rl as FileInput,
  E4 as Footer,
  Qr as FooterExtendedNavList,
  b4 as FooterNav,
  Fr as Form,
  Pe as FormGroup,
  bl as GovBanner,
  Vl as Grid,
  Hl as GridContainer,
  e4 as Header,
  ae as Icon,
  i4 as IconList,
  o4 as IconListContent,
  r4 as IconListIcon,
  l4 as IconListItem,
  h4 as IconListTitle,
  m4 as Identifier,
  d4 as IdentifierGov,
  v4 as IdentifierIdentity,
  g4 as IdentifierLink,
  u4 as IdentifierLinkItem,
  w4 as IdentifierLinks,
  p4 as IdentifierLogo,
  f4 as IdentifierLogos,
  M4 as IdentifierMasthead,
  wl as InPageNavigation,
  Ul as InputGroup,
  Yl as InputPrefix,
  Wl as InputSuffix,
  He as Label,
  Kl as LanguageSelector,
  Lt as LanguageSelectorButton,
  ue as Link,
  z4 as Logo,
  rt as MediaBlockBody,
  t4 as MegaMenu,
  Pr as Menu,
  C4 as Modal,
  k4 as ModalFooter,
  L4 as ModalHeading,
  y4 as ModalOpenLink,
  N4 as ModalToggleButton,
  kt as NavCloseButton,
  a4 as NavDropDownButton,
  ke as NavList,
  s4 as NavMenuButton,
  El as Pagination,
  n4 as PrimaryNav,
  I4 as ProcessList,
  G4 as ProcessListHeading,
  Z4 as ProcessListItem,
  Il as Radio,
  Zl as RangeInput,
  zt as RequiredMarker,
  U4 as Search,
  Gl as Select,
  xl as SideNav,
  j4 as SiteAlert,
  _4 as SocialLink,
  S4 as SocialLinks,
  P4 as StepIndicator,
  R4 as StepIndicatorStep,
  Y4 as SummaryBox,
  K4 as SummaryBoxContent,
  W4 as SummaryBoxHeading,
  pl as Table,
  fl as Tag,
  Ve as TextInput,
  jl as TextInputMask,
  vr as Textarea,
  ql as TimePicker,
  c4 as Title,
  Ml as Tooltip,
  Ql as ValidationChecklist,
  Jl as ValidationItem
};
//# sourceMappingURL=index.js.map
